import React, { useState, useEffect, useContext, useMemo, useRef, useCallback } from 'react';
import { useParams, Link, useHistory } from 'react-router-dom';
import { UserContext } from '../../context/UserContext';
import Header from '../Header/Header';
import Footer from '../Footer/Footer';
import './Detail.css';
import './comment-fix.css'; // 导入修复评论窗口圆角的CSS
import './toast.css'; // 导入提示弹窗样式
import './hover-patch.css'; // 导入修复按钮悬停效果的CSS
import { getAIResponse, getPuzzleById, getApiCallStatus } from '../../services/aiService';
import QuestionAnalyzer from '../../utils/questionAnalyzer';
import Loading from '../Loading/Loading'; // 添加导入Loading组件

const Detail = () => {
  const { id } = useParams();
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [isAuthor, setIsAuthor] = useState(false);
  const [currentUser, setCurrentUser] = useState(null);
  const [reportDialogOpen, setReportDialogOpen] = useState(false);
  const [reportTarget, setReportTarget] = useState(null);
  const [reportReason, setReportReason] = useState('spam');
  const [reportDetail, setReportDetail] = useState('');
  const [reportDetailRequired, setReportDetailRequired] = useState(false);
  const [loadingComments, setLoadingComments] = useState(true);
  const [puzzle, setPuzzle] = useState(null);
  const [showSolution, setShowSolution] = useState(false);
  const [loading, setLoading] = useState(true);
  const [question, setQuestion] = useState('');
  const [aiResponses, setAiResponses] = useState([]);
  const [asking, setAsking] = useState(false);
  const [isGameStarted, setIsGameStarted] = useState(false);
  const [isGameFinished, setIsGameFinished] = useState(false);
  const [remainingQuestions, setRemainingQuestions] = useState(20);
  const [guessInput, setGuessInput] = useState('');
  const [guessResult, setGuessResult] = useState(null);
  const [turtleCoins, setTurtleCoins] = useState(100);
  const [showCoinAlert, setShowCoinAlert] = useState(false);
  const COINS_PER_QUESTION = 24;
  const [notification, setNotification] = useState(null);
  const [successMessage, setSuccessMessage] = useState('');
  const API_URL = 'https://free.v36.cm';
  const [isLoading, setIsLoading] = useState(false);
  const [isLiked, setIsLiked] = useState(false);
  const [isSaved, setIsSaved] = useState(false);
  const [likeCount, setLikeCount] = useState(0);
  const [shareCount, setShareCount] = useState(0);
  const [isShared, setIsShared] = useState(false);
  const [showExitConfirm, setShowExitConfirm] = useState(false);
  const [exitDestination, setExitDestination] = useState('');
  const [questionAnalyzer, setQuestionAnalyzer] = useState(null);
  const [inputMode, setInputMode] = useState('question');
  const [showShareDialog, setShowShareDialog] = useState(false);
  const [comments, setComments] = useState([]);
  const [commentText, setCommentText] = useState('');
  const [replyingTo, setReplyingTo] = useState(null);
  const [showAllComments, setShowAllComments] = useState(false);
  const [likedComments, setLikedComments] = useState({});
  const [replyingToReply, setReplyingToReply] = useState(false);
  const [replyingToParent, setReplyingToParent] = useState(null);
  const [commentsLoaded, setCommentsLoaded] = useState(false);
  // 组件开始时添加依赖跟踪标志
  const [commentsInitialized, setCommentsInitialized] = useState(false);
  // 初始化评论区的加载状态和重新渲染控制
  const [commentsRenderComplete, setCommentsRenderComplete] = useState(false);
  // 在组件中添加宽度计算状态和引用
  const puzzleContentRef = useRef(null);
  const [contentWidth, setContentWidth] = useState(0);
  // 在组件顶部的state定义处添加新的state变量
  // const [newComment, setNewComment] = useState('');
  
  // 添加关注功能的状态
  const [isFollowing, setIsFollowing] = useState(false);
  const [isReportDropdownOpen, setIsReportDropdownOpen] = useState(false);
  
  // 处理关注按钮点击
  const handleFollow = () => {
    // 获取之前的关注状态
    const previousState = isFollowing;
    
    // 切换关注状态
    setIsFollowing(!previousState);
    
    // 根据新状态显示通知
    showNotification(!previousState ? '关注成功' : '已取消关注');
    
    // 可以在这里添加数据持久化逻辑，例如保存到localStorage或发送API请求
    const followedCreators = JSON.parse(localStorage.getItem('followedCreators') || '{}');
    
    if (!previousState) {
      // 关注创作者
      followedCreators[puzzle.creator] = true;
    } else {
      // 取消关注创作者
      delete followedCreators[puzzle.creator];
    }
    
    // 保存更新后的关注状态
    localStorage.setItem('followedCreators', JSON.stringify(followedCreators));
  };
  
  useEffect(() => {
    setLoading(true);
    
    setTimeout(() => {
      const puzzlesData = [
        {
          id: 1,
          title: '消失的旅客',
          description: '一列火车穿过隧道，出来时少了一名乘客...',
          coverImage: '/images/puzzle1.jpg',
          content: '一列夜间火车从上海开往北京，车上有50位乘客和6名工作人员。在经过一个长达15分钟的隧道后，列车员进行例行检票时发现一名乘客不见了。他的座位上只留下了一本翻开的书和一杯半满的咖啡。列车员立即报告给列车长，后者下令搜索整列火车，但没有找到这名乘客。隧道内没有停车，所有车门都处于锁闭状态，列车监控显示没有人在隧道内开门或跳车。到达北京站后，警方彻查了隧道，但没有任何乘客的踪迹。更奇怪的是，这名乘客的行李和所有个人物品都消失了，仿佛他从未登上过这列火车。',
          solution: '这名"消失"的乘客实际上是列车员团队的一员，他们正在进行一场针对乘客的沉浸式剧场表演。这名"乘客"在进入隧道前开始假装成普通乘客，在隧道中趁着黑暗换回了列车员制服，然后继续执行他的工作。他的"个人物品"被其他参与表演的列车员收走，只留下书和咖啡作为线索。这是铁路公司新推出的"神秘旅程"体验服务的一部分，旨在为长途旅行的乘客提供意外惊喜和讨论话题。这些表演通常会在旅程结束时揭晓，但这次由于有乘客报警，活动被提前终止。',
          creator: '拍拍',
          date: '2025-02-28',
          difficulty: 'medium',
          views: 224,
          comments: 4,
          favorites: 128,
          tags: ['悬疑', '交通', '消失'],
          category: '悬疑'
        },
        {
          id: 2,
          title: '奇怪的遗嘱',
          description: '富翁留下的遗嘱中只有一句话：向北走十步...',
          coverImage: '/images/puzzle2.jpg',
          content: '亿万富翁李先生去世后，律师向家人宣读了他的遗嘱。出乎所有人意料的是，这份遗嘱上只写了一句话："向北走十步，然后向东走五步，你会找到我真正的财富。"家人们都困惑不已，李先生生前住在一座位于山顶的大宅邸，从房子向北十步是悬崖边缘，向东五步则会坠入深谷。没有人敢按照遗嘱行动，最终家人们不得不按照法律程序平分李先生的财产。一年后，李先生的小孙子在院子里玩耍时，意外发现了祖父书房的地板上刻有微小的指南针标志，指向正北方向。他按照遗嘱的指示从这里出发，走了十步到达书房北墙壁，然后向东走了五步，停在一副古老的中国山水画前。出于好奇，他取下画，发现墙上有一个隐藏的保险箱，里面装满了价值连城的珠宝和一张纸条："真正的财富不是这些珠宝，而是寻找的过程和你的智慧。"',
          solution: '李先生的遗嘱指示的起点不是他的房子，而是他书房地板上的指南针标记——这个细节只有真正了解他的人才会注意到。李先生故意设计了这个谜题，为的是确保他的财富只会被那些足够聪明和耐心的家人发现，而不是那些只关心金钱的人。他的小孙子经常和他在书房里一起读书和玩耍，是唯一记得这个特殊标记的人。通过这种方式，李先生不仅测试了家人的智慧，也确保了他真正的精神继承人能够得到额外的奖励。这个故事的寓意是，有时候财富就在我们身边，但需要不同的视角去发现它。',
          creator: '拍拍',
          date: '2025-02-25',
          difficulty: 'hard',
          views: 287,
          comments: 4,
          favorites: 93,
          tags: ['谜题', '财富', '家族'],
          category: '推理'
        },
        {
          id: 3,
          title: '雨夜里的陌生人',
          description: '暴雨中，一个陌生人敲响了门，却带来了一个不可思议的秘密...',
          coverImage: '/images/puzzle3.jpg',
          content: '一个雨夜，马克独自在家。突然，一阵急促的敲门声传来。门外站着一个浑身湿透的陌生人，他说自己的车在附近抛锚了，想借用电话。马克让他进来，给了他毛巾擦干。陌生人接过毛巾，道谢后说了一句奇怪的话："你家里的挂钟还是慢了5分钟。"马克惊讶地看着墙上的挂钟，确实比他的手表慢了5分钟，但他从未见过这个人，这个人怎么会知道他家的钟慢了？当马克转身想问时，陌生人已经不见了，而外面的暴雨依然在继续。',
          solution: '这个陌生人实际上是未来的马克。由于一场时间实验事故，他被短暂地送回了过去。他知道挂钟慢了5分钟是因为这是他自己家的钟。他借口车抛锚只是为了进入屋内，确认自己确实回到了过去的特定时间点。当他确认后，实验装置将他带回了未来，这就是为什么他突然消失。年轻的马克将来会成为一名时间研究科学家，而这次偶然的相遇实际上是促使他走上这条道路的关键事件。',
          creator: '拍拍',
          date: '2025-03-05',
          difficulty: 'hard',
          views: 332,
          comments: 4,
          favorites: 215,
          tags: ['科幻', '时间', '陌生人'],
          category: '科幻'
        },
        {
          id: 4,
          title: '空中楼阁',
          description: '他看到了一座悬浮在空中的城堡，但没人相信他...',
          coverImage: '/images/puzzle4.jpg',
          content: '小镇上的摄影师汤姆在清晨拍风景时，意外地在照片上发现了一座悬浮在云层中的巨大城堡。这座城堡只出现在他的照片中，肉眼无法看到。他向小镇居民展示照片，但所有人都嘲笑他是PS的结果。汤姆决心证明城堡的存在，他开始每天早上在同一地点拍照，并记录下城堡的变化。他发现城堡在月圆之夜会更加清晰，而在新月时几乎看不见。更令人惊讶的是，城堡似乎在缓慢移动，每天位置都略有不同。三个月后的一天，汤姆带着所有照片去见了当地大学的一位物理学教授。当教授看完所有资料后，他的脸色变得苍白，立即打电话给了军方。第二天，小镇被军队封锁，汤姆被秘密带走，再也没有人见过他。',
          solution: '汤姆偶然发现的"城堡"实际上是一个隐形军事基地，使用了实验性的光学隐形技术。这种技术可以使建筑物对肉眼不可见，但在某些特定光线和大气条件下（如清晨和月圆之夜），普通相机可以捕捉到它的存在。基地在云层中移动是因为它实际上是一个浮空平台，用于高空监视和军事实验。军方获知此事后，立即将汤姆招募进入一个秘密项目，利用他发现的技术漏洞来改进隐形系统。他现在作为技术顾问为军方工作，签署了严格的保密协议，因此无法与外界联系。',
          creator: '拍拍',
          date: '2025-04-01',
          difficulty: 'medium',
          views: 245,
          comments: 4,
          favorites: 84,
          tags: ['军事', '科技', '秘密'],
          category: '科幻'
        },
        {
          id: 5,
          title: '镜中世界',
          description: '他发现镜子里的自己有时会做出不同的动作...',
          coverImage: '/images/puzzle5.jpg',
          content: '大学生李明在二手市场购买了一面古董镜子用于装饰他的新公寓。一天晚上，他无意中发现镜子里的自己有时会比他实际动作慢半拍，有时甚至会做出与他不同的动作。起初他以为是疲劳导致的幻觉，但随着时间推移，镜中的"另一个自己"变得越来越明显，甚至开始对他做出各种手势。更诡异的是，有时他会发现房间里的物品被移动了位置，尽管他确信自己没有碰过它们。一天深夜，他突然惊醒，发现镜子里的自己正站在床边俯视着他。惊恐之下，他摔碎了镜子，然后精疲力竭地睡去。第二天醒来时，他发现碎片已被清理干净，而镜子完好如初地挂在墙上。令他震惊的是，当他看向镜子时，里面的人对他微笑着说："现在轮到你了。"',
          solution: '这面古董镜子实际上是一件罕见的高维物理实验品，能够连接到平行宇宙。镜子里的"另一个李明"是平行宇宙中的他自己，两人通过镜子逐渐意识到彼此的存在。物品被移动是因为两个宇宙之间开始出现物质交换，而平行宇宙的李明想要与这个世界的李明互换位置，因此一直在尝试沟通和影响他。当他打碎镜子后，平行宇宙的李明找到了穿越的机会，趁他睡着时完成了互换。现在原来的李明被困在镜子另一边的平行宇宙中，而平行宇宙的李明则占据了他在这个世界的位置。',
          creator: '拍拍',
          date: '2025-04-13',
          difficulty: 'hard',
          views: 310,
          comments: 4,
          favorites: 176,
          tags: ['平行宇宙', '恐怖', '镜子'],
          category: '恐怖'
        },
        {
          id: 6,
          title: '午夜来电',
          description: '每天午夜，她都会收到一通未知号码的电话...',
          coverImage: '/images/puzzle6.jpg',
          content: '自从搬进新公寓后，林小雨每天午夜都会准时收到一通陌生来电。电话那头总是沉默几秒，然后是一个柔和的女声说出一串数字，随后挂断。起初她感到害怕，但几周后竟习以为常。她尝试过回拨，但号码无法接通；报警后，警方也查不到这个号码的来源。奇怪的是，当她偶尔熬夜到凌晨，却发现手机连接到未知WiFi网络，而且这个网络只在凌晨出现。更巧的是，网络名称正是那个女声每天报出的数字。某天，她鼓起勇气连接了这个WiFi，发现可以打开一个加密的网页，要求输入密码。在好奇心驱使下，她输入了女声最近一次报出的数字，网页显示了一段视频：一个与她长相几乎相同的女孩正对着摄像头微笑。',
          solution: '林小雨无意中租下的公寓曾是一名网络安全专家的家。这位专家发现了一个政府秘密监控项目，在被神秘势力追杀前，设置了这个自动系统，通过电话和WiFi向特定时间段在这个公寓的人传递信息。电话中的数字是不断变化的加密密钥，用于解锁她留下的证据。视频中的女孩是专家本人，她与林小雨相貌相似纯属巧合，但正是这个巧合让自动系统误以为林是有权接触这些信息的人。如果林继续深入调查，她会发现更多视频和文件，揭示整个秘密项目的内幕，但同时也会引来当年追杀那位专家的神秘势力的注意。',
          creator: '拍拍',
          date: '2025-03-21',
          difficulty: '中等',
          views: 224,
          comments: 4,
          favorites: 68,
          tags: ['科技', '悬疑', '阴谋'],
          category: '悬疑'
        },
        {
          id: 7,
          title: '沉默的窃贼',
          description: '银行被盗，但监控录像显示没有人进出...',
          coverImage: '/images/puzzle7.jpg',
          content: '一家位于市中心的大型银行在某个周末的深夜遭遇了一场离奇的盗窃案。保险库中存放的价值数百万的现金和贵重物品不翼而飞，银行职员在周一早晨发现时震惊不已。然而，当警方调取监控录像时，却发现整个周末期间都没有任何人进入或离开银行大楼。无论是正门、后门还是紧急出口，所有的监控摄像头都没有捕捉到任何可疑的身影。进一步的调查显示，保险库的锁没有被破坏的痕迹，内部也没有任何可疑的指纹、脚印或工具痕迹，仿佛现金是凭空消失的。唯一异常的线索是，银行的温度记录显示在盗窃当晚的午夜时分，室内温度突然下降了五度，持续了大约十分钟，然后又恢复正常。警方还发现，银行的安保系统在那一刻似乎出现了短暂的信号中断，但系统日志中没有任何被黑客入侵的迹象。这一切让调查人员百思不得其解，甚至有人开始怀疑是否涉及超自然力量。',
          solution: '这场盗窃案的背后隐藏着一种极为先进的低温技术。窃贼团队实际上是由一群顶尖科学家和职业罪犯组成的，他们开发了一种可以将人体暂时冷却到接近绝对零度的设备。在这种极端低温状态下，人的身体活动几乎完全停止，心跳和呼吸变得微乎其微，甚至连红外线监控设备都无法检测到他们的存在。窃贼在这种状态下悄然进入银行，利用事先获取的内部结构图，精准地抵达保险库，盗取了现金和贵重物品。由于他们的体温极低，周围环境的温度也随之短暂下降，这正是银行温度记录异常的原因。完成盗窃后，他们在温度恢复正常时离开，整个过程不留任何痕迹。这种技术的副作用是设备运行时会产生微弱的电磁干扰，导致安保系统信号短暂中断，但不足以触发警报。由于这种低温技术目前只有极少数人掌握，且属于高度机密，警方根本无法找到直接证据，甚至不知道从何处着手调查。最终，这起案件成为了一桩悬而未决的谜案。',
          creator: '拍拍',
          date: '2025-01-29',
          difficulty: 'hard',
          views: 356,
          comments: 4,
          favorites: 105,
          tags: ['科技', '犯罪', '悬疑'],
          category: '悬疑'
        },
        {
          id: 8,
          title: '诡异的录音',
          description: '科学家在无人岛上录到了人声...',
          coverImage: '/images/puzzle8.jpg',
          content: '一支由多国科学家组成的科考队在南太平洋的一个偏远无人岛上进行为期三个月的环境研究，旨在记录当地的生态系统和气候数据。在研究的第二个月，他们在岛上放置的录音设备意外捕捉到了一段令人毛骨悚然的模糊人声。录音中，一个低沉而沙哑的声音用一种陌生的语调反复念着一串数字，随后是一阵急促而沉重的呼吸声，仿佛说话者在极度恐惧或痛苦中，接着声音突然中断，录音回归一片寂静。科考队成员反复确认，岛上没有任何人类活动的迹象，也没有发现任何船只或飞机的踪迹，周围数十海里内都是无人区。起初，有人提出可能是设备故障或无线电信号干扰，但当他们将录音反复播放时，却发现数字序列似乎在每次播放时都会出现细微的变化，有时多一个数字，有时少一个数字，甚至语速和语气也略有不同。更令人不安的是，录音中的呼吸声似乎越来越清晰，甚至有队员声称在最后几次播放时听到了微弱的求救声。科考队内部开始弥漫恐惧情绪，有人提出立即撤离，但队长坚持完成研究，同时决定将录音带回基地进行更深入的分析。',
          solution: '这段诡异的录音实际上源自一个早已沉没的军用潜艇发出的信号。几十年前，一艘执行秘密任务的潜艇在该海域附近失踪，艇上搭载的紧急信号发射器在海底持续工作了数十年，顽强地发送着求救信号和位置坐标。无人岛附近特殊的海底地质结构和水下声波传播路径形成了一种罕见的声学现象，使得信号在特定条件下被科考队的录音设备意外捕捉到。录音中数字序列的变化是由于信号在海底环境中受到干扰，海流、温度变化和海底地形的影响导致每次接收到的信号片段略有不同。而呼吸声和求救声的逐渐清晰，则是由于科考队在岛上停留时间越长，设备接收到的信号累积越多，部分被掩盖的音频片段被逐渐还原。最终，科考队将录音交给军方进行分析，军方通过信号中的坐标信息锁定了潜艇的沉没位置，并在深海中发现了潜艇残骸。残骸中找到的黑匣子显示，潜艇失踪时曾遭遇不明攻击，艇员在最后时刻录下了求救信息。这段录音不仅解开了一个科学谜团，也揭开了尘封多年的军事悲剧。',
          creator: '拍拍',
          date: '2025-01-13',
          difficulty: 'medium',
          views: 302,
          comments: 4,
          favorites: 156,
          tags: ['神秘', '科技', '海洋'],
          category: '恐怖'
        }
      ];
      
      const puzzleId = parseInt(id);
      const selectedPuzzle = puzzlesData.find(puzzle => puzzle.id === puzzleId);
      
      if (selectedPuzzle) {
        setPuzzle(selectedPuzzle);
        // 将当前谜题保存到localStorage，以便AI服务可以获取
        localStorage.setItem('currentPuzzle', JSON.stringify(selectedPuzzle));
      } else {
        // 不再默认显示第一个海龟汤，而是将puzzle保持为null，显示404页面
        setPuzzle(null);
        localStorage.removeItem('currentPuzzle');
      }
      
      setLoading(false);
      console.log("URL ID:", id);
      console.log("Parsed ID:", puzzleId);
      console.log("Selected Puzzle:", selectedPuzzle ? selectedPuzzle.title : "海龟汤作品不存在");
    }, 1500); // 将加载时间从800ms改为1500ms
  }, [id]);
  
  useEffect(() => {
    const likedPuzzles = JSON.parse(localStorage.getItem('likedPuzzles') || '{}');
    if (puzzle && likedPuzzles[puzzle.id]) {
      setIsLiked(true);
    } else {
      setIsLiked(false);
    }
  }, [puzzle]);
  
  useEffect(() => {
    if (puzzle) {
      setLikeCount(puzzle.favorites || 0);
      setShareCount(puzzle.shares || 0);
    }
  }, [puzzle]);
  
  useEffect(() => {
    if (puzzle) {
      setQuestionAnalyzer(new QuestionAnalyzer(puzzle));
    }
  }, [puzzle]);
  
  useEffect(() => {
    if (puzzle && !commentsInitialized) {
      setLoadingComments(true);
      
      // 延迟加载模拟异步获取评论
      setTimeout(() => {
        const mockComments = [
          {
            id: 1,
            userId: 101,
            user: "Ethan Zyc",
            isAuthor: false,
            avatar: "/images/avatars/user1.jpg",
            content: "哎哟，不错哦",
            date: "2025-04-22",
            time: "14:35",
            likes: 24,
            replies: [
              {
                id: 101,
                userId: 200,
                user: "拍拍",
                isAuthor: true,
                avatar: "/images/avatars/user2.jpg",
                content: "o(^▽^)o 感谢张总",
                date: "2025-04-22",
                time: "15:42",
                likes: 16,
                replies: []
              }
            ]
          },
          {
            id: 2,
            userId: 102,
            user: "孙昱睿",
            isAuthor: false,
            avatar: "/images/avatars/user3.jpg",
            content: "我丢！丁总做的就是有实力啊 (๑•̀ㅂ•́)و✧",
            date: "2025-04-21",
            time: "18:22",
            likes: 5,
            replies: [
              {
                id: 102,
                userId: 103,
                user: "庆杰",
                isAuthor: false,
                avatar: "/images/avatars/user4.jpg",
                content: "确实，非常好玩啊！",
                date: "2025-04-21",
                time: "19:05",
                likes: 8,
                replies: []
              },
              {
                id: 103,
                userId: 103,
                user: "拍拍",
                isAuthor: true,
                avatar: "/images/avatars/user4.jpg",
                content: "感谢孙总和袁总！(≧ω≦)",
                date: "2025-04-21",
                time: "19:32",
                likes: 8,
                replies: []
              }
            ]
          },
          {
            id: 3,
            userId: 200,
            user: "拍拍",
            isAuthor: true,
            avatar: "/images/avatars/user5.jpg",
            content: "哈哈哈 居然这么多点赞了！(*^▽^*)",
            date: "2025-04-21",
            time: "09:01",
            likes: 18,
            replies: []
          },
          {
            id: 3,
            userId: 200,
            user: "赫哥赫哥",
            isAuthor: false,
            avatar: "/images/avatars/user5.jpg",
            content: "丁总这么强！o_O",
            date: "2025-04-22",
            time: "12:31",
            likes: 4,
            replies: []
          }
        ];
        
        setComments(mockComments);
        const storedLikedComments = JSON.parse(localStorage.getItem('likedComments') || '{}');
        setLikedComments(storedLikedComments);
        setLoadingComments(false);
        setCommentsInitialized(true); // 标记评论已初始化，避免重复加载
        
        // 标记评论渲染完成
        setTimeout(() => {
          setCommentsRenderComplete(true);
        }, 100);
      }, 1000);
    }
  }, [puzzle, commentsInitialized]); // 只在puzzle或commentsInitialized变化时触发
  
  const handleStartGame = () => {
    setIsGameStarted(true);
    setIsGameFinished(false);
    setShowSolution(false);
    setAiResponses([]);
    setRemainingQuestions(20);
    setGuessInput('');
    setGuessResult(null);
  };
  
  const handleAddQuestions = () => {
    if (turtleCoins >= COINS_PER_QUESTION) {
      setTurtleCoins(prev => prev - COINS_PER_QUESTION);
      setRemainingQuestions(prev => prev + 3);
      
      // 使用弹窗通知替代消息提示
      showNotification(`成功兑换! 已添加 3 次提问机会，消耗 ${COINS_PER_QUESTION} 海龟币`, 'success');
      // 不再需要以下代码，由showNotification处理
      // setSuccessMessage(`已添加3次提问机会，消耗${COINS_PER_QUESTION}海龟币`);
      // setTimeout(() => setSuccessMessage(''), 3000);
    } else {
      setShowCoinAlert(true);
      setTimeout(() => setShowCoinAlert(false), 3000);
    }
  };

  const calculateSimilarity = (str1, str2) => {
    const s1 = str1.toLowerCase().replace(/[^\u4e00-\u9fa5a-z0-9]/g, '');
    const s2 = str2.toLowerCase().replace(/[^\u4e00-\u9fa5a-z0-9]/g, '');
    
    if (s1.length === 0 && s2.length === 0) return 1.0;
    if (s1.length === 0 || s2.length === 0) return 0.0;
    
    const lcsMatrix = Array(s1.length + 1).fill().map(() => Array(s2.length + 1).fill(0));
    
    for (let i = 1; i <= s1.length; i++) {
      for (let j = 1; j <= s2.length; j++) {
        if (s1[i - 1] === s2[j - 1]) {
          lcsMatrix[i][j] = lcsMatrix[i - 1][j - 1] + 1;
        } else {
          lcsMatrix[i][j] = Math.max(lcsMatrix[i - 1][j], lcsMatrix[i][j - 1]);
        }
      }
    }
    
    const lcsLength = lcsMatrix[s1.length][s2.length];
    const maxLength = Math.max(s1.length, s2.length);
    
    return lcsLength / maxLength;
  };

  const handleSubmitGuess = async (e) => {
    e.preventDefault();
    if (!guessInput.trim()) return;

    setIsLoading(true);
    
    try {
      console.log("正确答案:", puzzle.solution);
      console.log("用户答案:", guessInput);
      console.log("相似度:", calculateSimilarity(guessInput, puzzle.solution));
      
      const similarity = calculateSimilarity(guessInput, puzzle.solution);
      // 修改判断标准，只要达到0.95（95%）的相似度就算正确
      const isCorrect = similarity >= 0.95;
      
      if (isCorrect) {
        // 使用弹窗通知显示结果
        showNotification('恭喜你猜对了！页面即将跳转', 'success');
        setIsGameFinished(true);
        
        setTimeout(() => {
          history.push(`/success/${puzzle.id}`);
        }, 1500);
      } else {
        let message = '很遗憾，答案不正确';
        if (similarity > 0.7) {
          message = '很接近了，再仔细想想？';
        } else if (similarity > 0.5) {
          message = '思路有些接近，但还需调整';
        } else {
          message = '答案差距较大，请重新思考';
        }
        
        // 使用弹窗通知显示错误提示
        showNotification(message, 'error');
      }
    } catch (error) {
      console.error('判断答案出错:', error);
      // 使用弹窗通知显示错误
      showNotification('判断答案时出现错误，请重试', 'error');
    } finally {
      setIsLoading(false);
    }
    
    // 不要在这里清空输入，以便用户可以修改
    // setGuessInput('');
  };

  // 周杰伦歌词匹配功能
  const matchJayChouLyrics = (input) => {
    const lyricsMap = {
      "天青色等烟雨": "而我在等你",
      "故事的小黄花": "从出生那年就飘着",
      "窗外的麻雀": "在电线杆上多嘴",
      "为你弹奏肖邦的夜曲": "纪念我死去的爱情",
      "我只能永远读着对白": "读着我给你的伤害",
      "还记得你说家是唯一的城堡": "随着稻香河流继续奔跑",
      "后视镜里的世界": "越来越远的道别",
      "我一路向北": "离开有你的季节",
      "我想就这样牵着你的手不放开": "爱可不可以简简单单没有伤害",
      "多想藏着你的好": "只有我看得到",
      "雨下整夜": "我的爱溢出就像雨水",
      "我知道你我都没有错": "只是忘了怎么退后",
      "无关风月": "我题序等你回",
      "明明就不习惯牵手": "为何却主动把手勾",
      "想要有直升机": "想要和你飞到宇宙去",
      "乌云在我们心里搁下一块阴影": "我聆听沉寂已久的心情",
      "缓缓飘落的枫叶像思念": "我点燃烛火温暖岁末的秋天",
      "不要你离开": "距离隔不开",
      "你的回话凌乱着": "在这个时刻",
      "天空灰得像哭过": "离开你以后 并没有 更自由",
      "地上断了翅的蝶": "雾散之后的满月",
      "白色的风车": "安静的转着",
      "能不能给我一首歌的时间": "把故事听到最后才说再见",
      "一件黑色毛衣": "两个人的回忆",
      "穿梭时间的画面的钟": "从反方向 开始移动",
      "一起长大的约定": "那样清晰 打过勾的我相信",
      "转身离开": "你有话说不出来",
      "剑出鞘恩怨了谁笑": "我只求今朝拥你入怀抱",
      "没有圆周的钟": "失去旋转意义",
      "最美的不是下雨天": "是曾与你躲过雨的屋檐",
      "古巴比伦王颁布了汉摩拉比法典": "刻在黑色的玄武岩 距今三千七百多年",
      "听妈妈的话": "别让她受伤",
      "躺在你学校的操场看星空": "教室里的灯还亮着 你没走",
      "雨纷纷": "旧故里草木深",
      "说了再见": "才发现再也见不到",
      "我是如此相信": "在背后支撑的是你",
      "龙卷风": "把我卷到你的世界",
      "走廊灯关上书包放": "走到房间窗外望",
      "我们的开始": "是很长的电影",
      "你发如雪": "凄美了离别",
      "我害怕你心碎没人帮你擦眼泪": "别管那是非 只要我们感觉对",
      "我会发着呆然后微微笑": "接着紧紧闭上眼",
      "眼看着你难过": "挽留的话却没有说",
      "翻着我们的照片": "想念若隐若现",
      "只剩下钢琴陪我谈了一天": "睡着的大提琴 安静的旧旧的",
      "我看着你的脸轻刷着和弦": "情人节卡片 手写的永远",
      "爱像一阵风": "吹完它就走",
      "我顶着大太阳": "只想为你撑伞"
    };
    
    return lyricsMap[input] || null;
  };
  
  // 修改handleSubmitQuestion函数
  const handleSubmitQuestion = async (e) => {
    e.preventDefault();
    if (!question.trim() || !isGameStarted || remainingQuestions <= 0 || isLoading) {
      return;
    }
    
    setIsLoading(true);
    
    try {
      // 检查是否是周杰伦歌词
      const lyricResponse = matchJayChouLyrics(question.trim());
      
      if (lyricResponse) {
        // 如果匹配到周杰伦歌词，直接返回对应的下一句
        const newResponse = {
          question: question,
          answer: lyricResponse,
          isRelated: true,
          type: "lyric"
        };
        
        const responseIndex = aiResponses.length;
        setAiResponses(prev => [...prev, newResponse]);
        
        // 自动滚动到新回答位置
        setTimeout(() => {
          const chatMessages = document.querySelector('.chat-messages');
          if (chatMessages) {
            const newMessageElement = chatMessages.children[responseIndex];
            if (newMessageElement) {
              newMessageElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
            } else {
              chatMessages.scrollTop = chatMessages.scrollHeight;
            }
          }
        }, 100);
      } else {
        // 直接使用API进行问答
        // 创建空的回答对象
        const newResponse = {
          question: question,
          answer: "正在思考中...", // 初始化为"正在思考中..."
          isRelated: true,
          type: "api",
          apiStatus: "pending" // 添加API状态追踪
        };
        
        const responseIndex = aiResponses.length;
        setAiResponses(prev => [...prev, newResponse]);
        
        try {
          console.log('准备向API发送问题...');
          
          // 构造完整的问题，提供足够上下文
          const apiQuestion = `我正在解决一个名为"${puzzle.title}"的海龟汤谜题。谜题内容：${puzzle.content}\n\n我的问题是：${question}`;
          
          // 步骤1：连接服务 - 更详细的状态提示
          setAiResponses(prev => {
            const updated = [...prev];
            updated[updated.length - 1].answer = "正在连接 API 服务...";
            updated[updated.length - 1].apiStatus = "connecting";
            return updated;
          });
          
          // 等待一秒钟，给用户一个过渡的感觉
          await new Promise(resolve => setTimeout(resolve, 800));
          
          // 步骤2：发送请求 - 更详细的状态提示
          setAiResponses(prev => {
            const updated = [...prev];
            updated[updated.length - 1].answer = "正在发送请求到Qwen3模型...";
            updated[updated.length - 1].apiStatus = "sending";
            return updated;
          });
          
          // 再等待一秒钟
          await new Promise(resolve => setTimeout(resolve, 800));
          
          // 步骤3：等待模型响应 - 更详细的状态提示
          setAiResponses(prev => {
            const updated = [...prev];
            updated[updated.length - 1].answer = "模型正在生成回答中...";
            updated[updated.length - 1].apiStatus = "processing";
            return updated;
          });
          
          try {
            // 显示控制台消息，指示真实API调用开始
            console.log('%c准备执行真实API调用', 'background: #4CAF50; color: white; padding: 4px 8px; border-radius: 4px; font-weight: bold;');
            console.log('问题:', apiQuestion);
            
            // 更新进度提示
            setAiResponses(prev => {
              const updated = [...prev];
              updated[updated.length - 1].answer = "正在等待AI响应，请稍候...";
              updated[updated.length - 1].apiStatus = "waiting";
              return updated;
            });
            
            // 记录调用开始时间
            const apiStartTime = Date.now();
            
            // 直接调用API并计时
            const apiResponse = await getAIResponse(apiQuestion);
            
            // 计算实际API调用耗时
            const apiEndTime = Date.now();
            const apiDuration = (apiEndTime - apiStartTime) / 1000;
            console.log(`API调用完成，实际耗时: ${apiDuration}秒`);
            
            // 获取API调用状态（使用getApiCallStatus函数）
            let apiStatusInfo = "API调用已完成";
            let apiCallSuccessful = false;
            
            try {
              if (typeof getApiCallStatus === 'function') {
                const status = getApiCallStatus();
                apiStatusInfo = `API调用次数: ${status.callCount}, 成功: ${status.successful ? '是' : '否'}`;
                apiCallSuccessful = status.successful;
                console.log('API调用状态:', status);
              }
            } catch (e) {
              console.error('无法获取API状态:', e);
            }
            
            // 如果API调用太快（小于1秒），可能表示没有真正调用API
            if (apiDuration < 1) {
              console.warn('API调用异常地快，可能没有真正调用API');
              
              // 强制重新调用API
              console.log('%c检测到可能的假调用，强制再次调用API', 'background: #FF9800; color: white; padding: 4px 8px; border-radius: 4px; font-weight: bold;');
              
              // 更新提示信息
              setAiResponses(prev => {
                const updated = [...prev];
                updated[updated.length - 1].answer = "API响应异常，正在重新尝试...";
                updated[updated.length - 1].apiStatus = "retrying";
                return updated;
              });
              
              // 等待一秒
              await new Promise(resolve => setTimeout(resolve, 1000));
              
              // 再次尝试API调用
              const secondApiStartTime = Date.now();
              const secondApiResponse = await getAIResponse(apiQuestion);
              const secondApiEndTime = Date.now();
              const secondApiDuration = (secondApiEndTime - secondApiStartTime) / 1000;
              
              // 检查第二次调用
              if (secondApiDuration >= 1) {
                console.log(`第二次API调用成功，耗时: ${secondApiDuration}秒`);
                apiCallSuccessful = true;
                
                // 使用第二次调用的结果
                await new Promise(resolve => setTimeout(resolve, 500));
                
                setAiResponses(prev => {
                  const updated = [...prev];
                  updated[updated.length - 1].answer = secondApiResponse;
                  updated[updated.length - 1].apiStatus = "completed";
                  return updated;
                });
              } else {
                // 即使第二次调用也太快，使用第一次的结果但记录警告
                console.warn('第二次API调用也异常地快，使用原始结果但标记为可疑');
                
                setAiResponses(prev => {
                  const updated = [...prev];
                  updated[updated.length - 1].answer = apiResponse;
                  updated[updated.length - 1].apiStatus = "suspicious";
                  updated[updated.length - 1].debug = "API调用时间异常"; // 添加调试信息
                  return updated;
                });
              }
            } else {
              // 第一次调用看起来是合法的
              console.log('API调用验证通过，使用响应结果');
              
              // 添加一个短暂延迟，确保用户能看到"思考中"的状态变化
              await new Promise(resolve => setTimeout(resolve, 500));
              
              // 更新回答
              setAiResponses(prev => {
                const updated = [...prev];
                updated[updated.length - 1].answer = apiResponse;
                updated[updated.length - 1].apiStatus = "completed";
                // 在开发模式下添加调试信息
                if (process.env.NODE_ENV === 'development') {
                  updated[updated.length - 1].debug = apiStatusInfo;
                }
                return updated;
              });
            }
            
            // 成功获取回答后减少提问次数
            setRemainingQuestions(prev => prev - 1);
            
          } catch (apiError) {
            // API调用出错
            console.error('API调用失败:', apiError);
            
            // 提供友好的错误消息，但不显示"API调用失败"字样
            setAiResponses(prev => {
              const updated = [...prev];
              // 使用更友好的错误提示
              updated[updated.length - 1].answer = "网络请求遇到问题，为您提供备选回答: 是又不是";
              updated[updated.length - 1].apiStatus = "error";
              return updated;
            });
            
            // 减少提问次数，因为尝试已经算作一次提问
            setRemainingQuestions(prev => prev - 1);
          }
          
          // 自动滚动到新回答位置
          setTimeout(() => {
            const chatMessages = document.querySelector('.chat-messages');
            if (chatMessages) {
              chatMessages.scrollTop = chatMessages.scrollHeight;
            }
          }, 100);
          
        } catch (error) {
          console.error('问题处理过程中出错:', error);
          
          setAiResponses(prev => {
            const updated = [...prev];
            if (updated.length > 0) {
              // 使用友好的错误消息
              updated[updated.length - 1].answer = "处理请求时遇到问题，默认回答: 是又不是";
              updated[updated.length - 1].apiStatus = "error";
            }
            return updated;
          });
          
          // 减少提问次数，因为尝试已经算作一次提问
          setRemainingQuestions(prev => prev - 1);
        }
      }
    } catch (error) {
      console.error('处理问题时出错:', error);
      
      setAiResponses(prev => {
        const updated = [...prev];
        if (updated.length > 0 && updated[updated.length - 1].answer === "正在思考中...") {
          updated[updated.length - 1].answer = "发生意外错误，默认回答: 是又不是";
          updated[updated.length - 1].apiStatus = "error";
        }
        return updated;
      });
      
      // 减少提问次数，因为尝试已经算作一次提问
      setRemainingQuestions(prev => prev - 1);
    } finally {
      setIsLoading(false);
      setQuestion('');
    }
  };
  
  // 增强回答内容
  const enhanceAnswer = (originalAnswer, userQuestion, puzzleData) => {
    // 提取关键词
    const keywords = userQuestion.toLowerCase().split(/\s+/).filter(word => 
      word.length > 2 && !["的", "是", "在", "了", "和", "与", "或", "吗", "有", "什么"].includes(word)
    );
    
    // 检查故事内容中是否直接包含关键词
    const storyMatch = keywords.some(keyword => 
      puzzleData.content.toLowerCase().includes(keyword)
    );
    
    // 检查问题是否询问特定情境
    const askingForScenario = userQuestion.includes("什么情况") || 
                               userQuestion.includes("什么情景") || 
                               userQuestion.includes("发生了什么");
                               
    // 根据匹配情况和问题类型优化回答
    if (storyMatch && askingForScenario) {
      // 问题直接与故事内容相关，给出更详细的回答
      return originalAnswer + "（提示：您的问题直接触及了故事的关键点，继续深入思考此方向。）";
    } else if (storyMatch) {
      // 问题与故事有关，但不是询问情境
      return originalAnswer + "（您提到的内容与故事有关，可以从这个角度思考。）";
    } else if (askingForScenario) {
      // 询问情境但关键词不匹配
      return originalAnswer + "（建议仔细阅读故事内容，寻找更多线索。）";
    }
    
    return originalAnswer;
  };
  
  // 增强相关性检查
  const enhanceRelevanceCheck = (originalRelevance, userQuestion, puzzleData) => {
    // 检查问题中是否包含故事的关键元素
    const solutionKeywords = puzzleData.solution.toLowerCase().split(/\s+/).filter(word => 
      word.length > 2 && !["的", "是", "在", "了", "和", "与", "或", "吗", "有", "什么"].includes(word)
    );
    
    // 如果问题中包含解答中的关键词，认为问题相关性更高
    const keywordMatch = solutionKeywords.some(keyword => 
      userQuestion.toLowerCase().includes(keyword)
    );
    
    if (keywordMatch && !originalRelevance) {
      // 问题可能相关性被低估了
      return true;
    }
    
    return originalRelevance;
  };
  
  const handleLike = () => {
    if (isLiked) {
      setLikeCount(prev => prev - 1);
    } else {
      setLikeCount(prev => prev + 1);
    }
    
    const newLikeState = !isLiked;
    setIsLiked(newLikeState);
    
    if (puzzle) {
      const likedPuzzles = JSON.parse(localStorage.getItem('likedPuzzles') || '{}');
      if (newLikeState) {
        likedPuzzles[puzzle.id] = true;
      } else {
        delete likedPuzzles[puzzle.id];
      }
      localStorage.setItem('likedPuzzles', JSON.stringify(likedPuzzles));
    }
  };

  const handleShare = () => {
    setShowShareDialog(true);
  };
  
  const closeShareDialog = () => {
    setShowShareDialog(false);
  };

  const handleShareTo = (platform) => {
    const puzzleUrl = window.location.href;
    const puzzleTitle = puzzle.title;
    const puzzleDesc = puzzle.description;
    
    switch (platform) {
      case 'wechat-friend':
        showNotification('已生成分享链接，请打开微信扫描二维码');
        break;
      case 'wechat-moments':
        showNotification('已生成分享图片，请打开微信朋友圈发布');
        break;
      case 'qq':
        showNotification('已生成分享链接，请打开QQ分享');
        break;
      case 'forum':
        history.push(`/forum/new?share=${puzzle.id}&title=${encodeURIComponent(puzzleTitle)}`);
        break;
      default:
        break;
    }
    
    setShowShareDialog(false);
    setShareCount(prev => prev + 1);
    setIsShared(true);
    setTimeout(() => setIsShared(false), 1500);
  };

  const showNotification = (message, type = 'success', isLoginPrompt = false) => {
    // 清除之前的计时器（如果存在）
    if (window.notificationTimer) {
      clearTimeout(window.notificationTimer);
      window.notificationTimer = null;
    }
    
    // 设置通知内容，添加唯一key确保重新渲染
    setNotification({
      message,
      type,
      isLoginPrompt,
      key: Date.now() // 确保每次通知都是新的组件实例
    });
    
    // 强制重绘以确保动画生效
    requestAnimationFrame(() => {
      const toastElement = document.querySelector('.elegant-auth-toast');
      if (toastElement) {
        // 强制触发重排/重绘
        toastElement.style.display = 'none';
        const _ = toastElement.offsetHeight; // 触发重排
        toastElement.style.display = '';
      }
    });
    
    // 3秒后自动关闭通知
    window.notificationTimer = setTimeout(() => {
      setNotification(null);
    }, 3000);
  };
  
  // 组件卸载时清除通知定时器
  useEffect(() => {
    return () => {
      if (window.notificationTimer) {
        clearTimeout(window.notificationTimer);
        window.notificationTimer = null;
      }
    };
  }, []);
  
  const history = useHistory();

  const confirmExit = () => {
    setShowExitConfirm(false);
    if (exitDestination) {
      history.push(exitDestination);
    }
  };

  const cancelExit = () => {
    setShowExitConfirm(false);
    setExitDestination('');
  };

  const handleExitConfirm = (destination) => {
    // 直接进行页面跳转，不显示确认弹窗
    history.push(destination);
  };
  
  const handleCommentSubmit = (e) => {
    e.preventDefault();
    
    if (!commentText.trim()) return;
    
    if (!isLoggedIn) {
      showNotification('请先登录再发表评论', 'error', true);
      return;
    }
    
    const now = new Date();
    const currentDate = now.toISOString().split('T')[0];
    const currentTime = `${String(now.getHours()).padStart(2, '0')}:${String(now.getMinutes()).padStart(2, '0')}`;
    
    if (replyingToReply) {
      const updatedComments = comments.map(comment => {
        if (comment.id === replyingToParent) {
          return {
            ...comment,
            replies: comment.replies.map(reply => {
              if (reply.id === replyingTo) {
                const replies = reply.replies || [];
                return {
                  ...reply,
                  replies: [...replies, {
                    id: Date.now(),
                    userId: currentUser?.id || 999,
                    user: currentUser?.username || "当前用户",
                    isAuthor: isAuthor,
                    avatar: "/images/default.png", // 使用默认头像
                    content: commentText,
                    date: currentDate,
                    time: currentTime,
                    likes: 0,
                    replies: []
                  }]
                };
              }
              return reply;
            })
          };
        }
        return comment;
      });
      
      setComments(updatedComments);
      setReplyingTo(null);
      setReplyingToReply(false);
      setReplyingToParent(null);
      
    } else if (replyingTo) {
      const updatedComments = comments.map(comment => {
        if (comment.id === replyingTo) {
          return {
            ...comment,
            replies: [...(comment.replies || []), {
              id: Date.now(),
              userId: currentUser?.id || 999,
              user: currentUser?.username || "当前用户",
              isAuthor: isAuthor,
              avatar: "/images/default.png", // 使用默认头像
              content: commentText,
              date: currentDate,
              time: currentTime,
              likes: 0,
              replies: []
            }]
          };
        }
        return comment;
      });
      
      setComments(updatedComments);
      setReplyingTo(null);
    } else {
      const newComment = {
        id: Date.now(),
        userId: currentUser?.id || 999,
        user: currentUser?.username || "当前用户",
        isAuthor: isAuthor,
        avatar: "/images/default.png", // 使用默认头像
        content: commentText,
        date: currentDate,
        time: currentTime,
        likes: 0,
        replies: []
      };
      
      setComments([...comments, newComment]);
    }
    
    setCommentText('');
  };

  const handleLikeComment = (commentId, isReply = false, parentId = null) => {
    let commentKey = isReply ? `${parentId}-${commentId}` : `${commentId}`;
    
    // 创建新的点赞状态对象
    const newLikedComments = {...likedComments};
    const wasLiked = newLikedComments[commentKey];
    
    // 切换点赞状态 - 只对当前评论生效
    newLikedComments[commentKey] = !wasLiked;
    
    // 直接更新DOM以显示点赞效果
    const selector = isReply ? 
      `.reply-like[data-id="${commentId}"][data-parent="${parentId}"] span` : 
      `.comment-like[data-id="${commentId}"] span`;
    
    const likeButton = document.querySelector(selector);
    if (likeButton) {
      const currentLikes = parseInt(likeButton.textContent) || 0;
      likeButton.textContent = wasLiked ? (currentLikes - 1) : (currentLikes + 1);
      
      // 更新按钮样式
      const button = likeButton.closest('button');
      if (button) {
        if (wasLiked) {
          button.classList.remove('liked');
          button.querySelector('i').classList.replace('fas', 'far');
        } else {
          button.classList.add('liked');
          button.querySelector('i').classList.replace('far', 'fas');
        }
      }
    }
    
    // 创建一个新的评论数组副本
    const updatedComments = JSON.parse(JSON.stringify(comments));
    
    // 更新评论数据中的点赞数
    if (isReply) {
      for (let i = 0; i < updatedComments.length; i++) {
        if (updatedComments[i].id === parentId) {
          for (let j = 0; j < updatedComments[i].replies.length; j++) {
            if (updatedComments[i].replies[j].id === commentId) {
              const oldLikes = parseInt(updatedComments[i].replies[j].likes) || 0;
              updatedComments[i].replies[j].likes = wasLiked ? oldLikes - 1 : oldLikes + 1;
              break;
            }
          }
          break;
        }
      }
    } else {
      for (let i = 0; i < updatedComments.length; i++) {
        if (updatedComments[i].id === commentId) {
          const oldLikes = parseInt(updatedComments[i].likes) || 0;
          updatedComments[i].likes = wasLiked ? oldLikes - 1 : oldLikes + 1;
          break;
        }
      }
    }
    
    // 更新状态
    setComments(updatedComments);
    setLikedComments(newLikedComments);
    
    // 保存到localStorage
    localStorage.setItem('likedComments', JSON.stringify(newLikedComments));
    
    // 阻止事件冒泡
    return false;
  };

  const getCommentSummary = (commentId, isReply = false, parentId = null) => {
    if (isReply) {
      const parent = comments.find(c => c.id === parentId);
      if (parent) {
        const reply = parent.replies.find(r => r.id === commentId);
        if (reply) {
          const maxLength = 20;
          const content = reply.content;
          return content.length > maxLength ? `"${content.substring(0, maxLength)}..."` : `"${content}"`;
        }
      }
    } else {
      const comment = comments.find(c => c.id === commentId);
      if (comment) {
        const maxLength = 20;
        const content = comment.content;
        return content.length > maxLength ? `"${content.substring(0, maxLength)}..."` : `"${content}"`;
      }
    }
    return '';
  };
  
  const handleLogin = () => {
    history.push('/login');
  };
  
  useEffect(() => {
    const userLoginStatus = localStorage.getItem('userLoggedIn') === 'true';
    setIsLoggedIn(userLoginStatus);
    
    if (userLoginStatus) {
      setCurrentUser({
        id: 999,
        username: '当前用户',
        avatar: "/images/default.png"
      });
      
      if (puzzle && puzzle.creatorId === 999) {
        setIsAuthor(true);
      }
    }
  }, [puzzle]);
  
  // 修改举报对话框的逻辑
  const handleReportComment = (commentId, isReply = false, parentId = null) => {
    // 设置举报目标信息
    setReportTarget({
      commentId,
      isReply,
      parentId
    });
    
    // 打开举报对话框
    setReportDialogOpen(true);
    setReportReason('spam'); // 默认选择"垃圾信息"
    setReportDetail('');
  };

  // 提交举报的逻辑 (保留以防需要)
  const submitReport = () => {
    // 表单验证
    if (reportReason === 'other' && !reportDetail.trim()) {
      showNotification('请填写举报原因', 'error');
      return;
    }
    
    // 实际项目中应发送到服务器
    console.log('举报提交:', reportTarget, reportReason, reportDetail);
    
    // 显示成功提示
    showNotification('举报已提交，感谢您的反馈', 'success');
    
    // 关闭举报对话框
    setReportDialogOpen(false);
    setReportReason('spam');
    setReportDetail('');
  };

  // 取消举报
  const cancelReport = () => {
    setReportDialogOpen(false);
    setReportReason('spam');
    setReportDetail('');
  };

  // 添加删除评论功能
  const handleDeleteComment = (commentId, isReply = false, parentId = null) => {
    // 请求确认
    if (!window.confirm('确定要删除此评论吗？此操作不可撤销。')) {
      return;
    }
    
    if (isReply) {
      // 删除回复
      const updatedComments = comments.map(comment => {
        if (comment.id === parentId) {
          return {
            ...comment,
            replies: comment.replies.filter(reply => reply.id !== commentId)
          };
        }
        return comment;
      });
      
      setComments(updatedComments);
    } else {
      // 删除主评论
      const updatedComments = comments.filter(comment => comment.id !== commentId);
      setComments(updatedComments);
    }
    
    // 显示成功删除提示
    showNotification('评论已成功删除', 'success');
  };

  // 处理对回复的回复
  const handleReplyToReply = (replyId, parentId) => {
    setReplyingTo(replyId);
    setReplyingToReply(true);
    setReplyingToParent(parentId);
    
    // 找到要回复的评论
    const parent = comments.find(c => c.id === parentId);
    if (parent) {
      const reply = parent.replies.find(r => r.id === replyId);
      if (reply) {
        // 滚动到评论表单
        setTimeout(() => {
          const commentForm = document.getElementById('comment-form');
          if (commentForm) {
            commentForm.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
        }, 100);
      }
    }
  };

  // 获取被回复评论的用户名
  const getReplyUserName = () => {
    if (replyingToReply && replyingTo && replyingToParent) {
      const parent = comments.find(c => c.id === replyingToParent);
      if (parent) {
        const reply = parent.replies.find(r => r.id === replyingTo);
        return reply ? reply.user : '';
      }
    } else if (replyingTo) {
      const comment = comments.find(c => c.id === replyingTo);
      return comment ? comment.user : '';
    }
    return '';
  };
  
  // 修改加载状态的处理，确保布局稳定
  useEffect(() => {
    if (loadingComments) {
      // 预先设置一个最小高度，防止布局抖动
      document.body.classList.add('loading-comments');
    } else {
      document.body.classList.remove('loading-comments');
    }
    
    return () => {
      document.body.classList.remove('loading-comments');
    };
  }, [loadingComments]);
  
  // 使用严格的引用相等性比较来避免不必要的渲染
  const stableComments = useMemo(() => {
    return comments;
  }, [comments.length]); // 只在评论数量变化时更新引用
  
  // 内存化评论列表的渲染函数，避免不必要的DOM更新，并确保使用默认头像
  const renderComments = useCallback(() => {
    const commentsToShow = showAllComments ? stableComments : stableComments.slice(0, 3);
    
    return commentsToShow.map(comment => (
      <div key={comment.id} className="comment-item">
        <div className="comment-avatar">
          <img 
            src="/images/avatars/profile.jpg" 
            alt={comment.user} 
            loading="eager"
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = "/images/profile.png"; // 备用头像路径
            }}
          />
        </div>
        <div className="comment-content">
          <div className="comment-header">
            <div className="comment-user">
              {comment.user}
              {comment.isAuthor && <span className="author-badge" style={{
                background: 'linear-gradient(120deg, #ffdf5e 0%, #ffb347 100%)',
                fontFamily: '"Microsoft YaHei", "微软雅黑", sans-serif',
                fontWeight: 'bold'
              }}>作者</span>}
            </div>
            <div className="comment-date">
              {comment.date} {comment.time}
            </div>
          </div>
          <div className="comment-text">{comment.content}</div>
          <div className="comment-actions" style={{ display: 'flex', alignItems: 'center', gap: '15px', justifyContent: 'flex-start' }}>
            {/* 按钮组 */}
            <div style={{ display: 'flex', alignItems: 'center' }}>
              {/* 点赞按钮 */}
              <button
                className={`like-button comment-like ${likedComments[comment.id] ? 'liked' : ''}`}
                data-id={comment.id}
                onClick={() => handleLikeComment(comment.id)}
                style={{
                  background: 'none',
                  border: 'none',
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  marginRight: '0',
                  padding: '5px 10px 5px 5px',
                }}
              >
                <i 
                  className={likedComments[comment.id] ? 'fas fa-heart' : 'far fa-heart'} 
                  style={{ 
                    color: likedComments[comment.id] ? '#ffb347' : '#666',
                    marginRight: '4px',
                    background: likedComments[comment.id] ? 'linear-gradient(120deg, #ffdf5e 0%, #ffb347 100%)' : 'none',
                    WebkitBackgroundClip: likedComments[comment.id] ? 'text' : 'none',
                    WebkitTextFillColor: likedComments[comment.id] ? 'transparent' : 'inherit'
                  }}
                ></i>
                <span style={{ 
                  color: likedComments[comment.id] ? '#ffb347' : '#666',
                  background: likedComments[comment.id] ? 'linear-gradient(120deg, #ffdf5e 0%, #ffb347 100%)' : 'none',
                  WebkitBackgroundClip: likedComments[comment.id] ? 'text' : 'none',
                  WebkitTextFillColor: likedComments[comment.id] ? 'transparent' : 'inherit'
                }}>{comment.likes || 0}</span>
              </button>
            </div>
            
            {/* 添加回复按钮 */}
            <button
              className="reply-button"
              onClick={() => handleReplyToComment(comment.id)}
              style={{
                background: 'none',
                border: 'none',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                marginRight: '0',
                marginLeft: '0',
                padding: '5px 10px',
              }}
            >
              <i 
                className="far fa-comment" 
                style={{ 
                  color: '#666',
                  marginRight: '4px',
                }}
              ></i>
              <span style={{ 
                color: '#666',
              }}>回复</span>
            </button>
            
            <div className="comment-manage" style={{ display: 'flex', alignItems: 'center' }}>
              {currentUser && comment.userId === currentUser.id ? (
                <button 
                  className="comment-delete" 
                  onClick={() => handleDeleteComment(comment.id)}
                  style={{
                    padding: '5px 10px',
                  }}
                >
                  <i className="far fa-trash-alt" style={{ marginRight: '4px' }}></i>
                  <span>删除</span>
                </button>
              ) : (
                <button 
                  className="comment-report" 
                  onClick={() => handleReportComment(comment.id)}
                  style={{
                    padding: '5px 10px',
                  }}
                >
                  <i className="far fa-flag" style={{ marginRight: '4px' }}></i>
                  <span>举报</span>
                </button>
              )}
            </div>
          </div>
          
          {comment.replies && comment.replies.length > 0 && (
            <div className="replies-list">
              {comment.replies.map(reply => (
                <div key={reply.id} className="reply-item">
                  <div className="reply-avatar">
                    <img 
                      src="/images/profile.png" 
                      alt={reply.user} 
                      loading="eager"
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = "/images/profile.png"; // 备用头像路径
                      }}
                    />
                  </div>
                  <div className="reply-content">
                    <div className="reply-header">
                      <div className="reply-user">
                        {reply.user}
                        {reply.isAuthor && <span className="author-badge" style={{
                          background: 'linear-gradient(120deg, #ffdf5e 0%, #ffb347 100%)',
                          fontFamily: '"Microsoft YaHei", "微软雅黑", sans-serif',
                          fontWeight: 'bold'
                        }}>作者</span>}
                      </div>
                      <div className="reply-date">
                        {reply.date} {reply.time}
                      </div>
                    </div>
                    <div className="reply-text">{reply.content}</div>
                    <div className="reply-actions" style={{ display: 'flex', alignItems: 'center' }}>
                      {/* 点赞按钮 */}
                      <button
                        className={`like-button reply-like ${likedComments[`${comment.id}-${reply.id}`] ? 'liked' : ''}`}
                        data-id={reply.id}
                        data-parent={comment.id}
                        onClick={() => handleLikeComment(reply.id, true, comment.id)}
                        style={{
                          background: 'none',
                          border: 'none',
                          cursor: 'pointer',
                          display: 'flex',
                          alignItems: 'center',
                          marginRight: '0',
                          padding: '5px 5px',
                        }}
                      >
                        <i 
                          className={likedComments[`${comment.id}-${reply.id}`] ? 'fas fa-heart' : 'far fa-heart'} 
                          style={{ 
                            color: likedComments[`${comment.id}-${reply.id}`] ? '#ffb347' : '#666',
                            marginRight: '2px',
                            background: likedComments[`${comment.id}-${reply.id}`] ? 'linear-gradient(120deg, #ffdf5e 0%, #ffb347 100%)' : 'none',
                            WebkitBackgroundClip: likedComments[`${comment.id}-${reply.id}`] ? 'text' : 'none',
                            WebkitTextFillColor: likedComments[`${comment.id}-${reply.id}`] ? 'transparent' : 'inherit'
                          }}
                        ></i>
                        <span style={{ 
                          color: likedComments[`${comment.id}-${reply.id}`] ? '#ffb347' : '#666',
                          background: likedComments[`${comment.id}-${reply.id}`] ? 'linear-gradient(120deg, #ffdf5e 0%, #ffb347 100%)' : 'none',
                          WebkitBackgroundClip: likedComments[`${comment.id}-${reply.id}`] ? 'text' : 'none',
                          WebkitTextFillColor: likedComments[`${comment.id}-${reply.id}`] ? 'transparent' : 'inherit'
                        }}>{reply.likes || 0}</span>
                      </button>
                      
                      <div style={{ width: '18px', display: 'inline-block' }}></div>
                      
                      {/* 添加回复按钮 */}
                      <button
                        className="reply-button"
                        onClick={() => handleReplyToReply(reply.id, comment.id)}
                        style={{
                          background: 'none',
                          border: 'none',
                          cursor: 'pointer',
                          display: 'flex',
                          alignItems: 'center',
                          marginRight: '0',
                          padding: '5px 5px',
                        }}
                      >
                        <i 
                          className="far fa-comment" 
                          style={{ 
                            color: '#666',
                            marginRight: '4px',
                          }}
                        ></i>
                        <span style={{ 
                          color: '#666',
                        }}>回复</span>
                      </button>
                      
                      <div style={{ width: '12px', display: 'inline-block' }}></div>
                      
                      <div style={{ width: '0px', display: 'none' }}></div>
                      
                      <div className="reply-manage" style={{ display: 'flex', alignItems: 'center' }}>
                        {currentUser && reply.userId === currentUser.id ? (
                          <button 
                            className="reply-delete" 
                            onClick={() => handleDeleteComment(reply.id, true, comment.id)}
                          >
                            <i className="far fa-trash-alt"></i>
                            <span>删除</span>
                          </button>
                        ) : (
                          <button 
                            className="reply-report" 
                            onClick={() => handleReportComment(reply.id, true, comment.id)}
                          >
                            <i className="far fa-flag"></i>
                            <span>举报</span>
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    ));
  }, [showAllComments, stableComments, likedComments]); // 仅在这些依赖变化时重新计算
  
  // 添加一个独立的effect来强制稳定DOM渲染
  useEffect(() => {
    // 函数在操作DOM之前先让浏览器完成其渲染循环
    const stabilizeRendering = () => {
      const commentElements = document.querySelectorAll('.comment-item, .reply-item');
      if (!commentElements.length) return;
      
      // 强制触发重排以应用所有样式更改
      // 读取布局属性，然后设置样式，这样浏览器会在一个渲染循环内完成
      commentElements.forEach(el => {
        // 读取触发重排的属性
        const dummy = el.offsetHeight;
        // 然后设置样式
        el.style.transform = 'translateZ(0)';
        el.style.backfaceVisibility = 'hidden';
      });
    };
    
    // 组件挂载后延迟执行
    const timer = setTimeout(stabilizeRendering, 100);
    // 在评论加载完成后再次执行
    if (!loadingComments && comments.length > 0) {
      stabilizeRendering();
    }
    
    // 组件卸载时清理
    return () => clearTimeout(timer);
  }, [loadingComments, comments.length]);
  
  // 添加测量宽度的副作用
  useEffect(() => {
    if (puzzleContentRef.current && !contentWidth) {
      setContentWidth(puzzleContentRef.current.offsetWidth);
    }
    
    const handleResize = () => {
      if (puzzleContentRef.current) {
        setContentWidth(puzzleContentRef.current.offsetWidth);
      }
    };
    
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [puzzleContentRef, contentWidth]);
  
  // 添加回复函数
  const handleReplyToComment = (commentId) => {
    setReplyingTo(commentId);
    
    // 滚动到评论表单
    setTimeout(() => {
      const commentForm = document.getElementById('comment-form');
      if (commentForm) {
        commentForm.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }, 100);
  };
  
  // 添加truncateString工具函数
  const truncateString = (str, num) => {
    if (str.length <= num) {
      return str;
    }
    return str.slice(0, num) + '...';
  };
  
  // 默认头像路径
  const defaultAvatar = "/images/default.png";
  
  // 添加新评论时使用默认头像
  const addComment = () => {
    if (!commentText.trim()) return;
    
    if (!isLoggedIn) {
      showNotification('请先登录后发表评论', 'error', true);
      return;
    }
    
    const newCommentObj = {
      id: Date.now(),
      user: currentUser?.username || '匿名用户',
      userId: currentUser?.id || 0,
      avatar: defaultAvatar,
      content: commentText,
      date: new Date().toLocaleDateString(),
      time: new Date().toLocaleTimeString([], {hour: '2-digit', minute:'2-digit'}),
      likes: 0,
      replies: [],
      isAuthor: isAuthor
    };
    
    setComments([...comments, newCommentObj]);
    setCommentText('');
    
    // 显示成功通知
    showNotification('评论发表成功!', 'success');
  };
  
  // 处理评论数据渲染时使用CSS变量提高性能
  useEffect(() => {
    // 添加自定义CSS变量到:root以优化渲染
    document.documentElement.style.setProperty('--prevent-flicker', 'translateZ(0)');
    document.documentElement.style.setProperty('--comment-text-color', '#666');
    document.documentElement.style.setProperty('--comment-container', 'content');
    
    return () => {
      // 清理
      document.documentElement.style.removeProperty('--prevent-flicker');
      document.documentElement.style.removeProperty('--comment-text-color');
      document.documentElement.style.removeProperty('--comment-container');
    };
  }, []);
  
  // 修改防止闪烁的useEffect，使其更有效
  useEffect(() => {
    // 禁用所有动画和过渡效果
    document.documentElement.classList.add('no-transitions');
    document.body.classList.add('no-animations');
    
    // 禁用可能导致重绘的样式属性
    const disableRepaints = () => {
      const commentSection = document.querySelector('.comments-section');
      if (!commentSection) return;
      
      // 应用防止布局偏移的样式
      commentSection.style.contain = 'layout size style';
      commentSection.style.willChange = 'contents';
      commentSection.style.isolation = 'isolate';
      commentSection.style.transformStyle = 'preserve-3d';
      
      // 强制所有评论元素使用硬件加速
      const commentElements = document.querySelectorAll('.comment-item, .reply-item, .nested-reply-item');
      commentElements.forEach(el => {
        el.style.transform = 'translateZ(0)';
        el.style.backfaceVisibility = 'hidden';
        el.style.contain = 'layout paint style';
        el.style.willChange = 'transform';
        el.style.transformStyle = 'preserve-3d';
      });
      
      // 为评论头像添加稳定渲染样式
      const avatarImages = document.querySelectorAll('.comment-avatar img, .reply-avatar img');
      avatarImages.forEach(img => {
        img.style.contain = 'strict';
        img.style.willChange = 'transform';
        img.style.transform = 'translateZ(0)';
        img.loading = 'eager'; // 确保立即加载
        img.decoding = 'sync'; // 同步解码
        img.fetchPriority = 'high'; // 高优先级
      });
      
      // 禁用评论文本区域的动画和过渡
      const textElements = document.querySelectorAll('.comment-text, .reply-text');
      textElements.forEach(el => {
        el.style.transform = 'translateZ(0)';
        el.style.contain = 'style layout';
        el.style.willChange = 'contents';
      });
    };
    
    // 初次渲染后立即应用
    disableRepaints();
    
    // 在组件每次重新渲染后再次应用
    const observer = new MutationObserver(disableRepaints);
    const commentSection = document.querySelector('.comments-section');
    if (commentSection) {
      observer.observe(commentSection, { 
        childList: true,
        subtree: true,
        attributes: true
      });
    }
    
    return () => {
      document.documentElement.classList.remove('no-transitions');
      document.body.classList.remove('no-animations');
      if (observer) observer.disconnect();
    };
  }, []);

  // 优化评论加载逻辑
  useEffect(() => {
    if (loadingComments) {
      // 预先设置评论容器高度，防止加载时的布局偏移
      const commentsContainer = document.querySelector('.comments-container');
      if (commentsContainer) {
        commentsContainer.style.minHeight = '300px';
      }
    }
  }, [loadingComments]);
  
  // 将评论列表渲染固定下来，不要在渲染过程中更新DOM
  useEffect(() => {
    if (!loadingComments && comments.length > 0 && !commentsRenderComplete) {
      // 标记评论渲染完成，阻止不必要的重新渲染
      setCommentsRenderComplete(true);
    }
  }, [loadingComments, comments, commentsRenderComplete]);
  
  // 添加初始化评论的useEffect
  useEffect(() => {
    // 确保评论加载完成后再处理
    if (comments.length > 0 && !commentsInitialized) {
      // 转换现有评论，确保使用默认头像
      const updatedComments = comments.map(comment => ({
        ...comment,
        avatar: "/images/default.png",
        replies: (comment.replies || []).map(reply => ({
          ...reply,
          avatar: "/images/default.png",
          replies: (reply.replies || []).map(nestedReply => ({
            ...nestedReply,
            avatar: "/images/default.png"
          }))
        }))
      }));
      
      setComments(updatedComments);
      setCommentsInitialized(true);
      
      // 从localStorage加载点赞状态
      const savedLikedComments = localStorage.getItem('likedComments');
      if (savedLikedComments) {
        try {
          setLikedComments(JSON.parse(savedLikedComments));
        } catch (e) {
          console.error('无法解析保存的点赞状态:', e);
          setLikedComments({});
        }
      }
    }
  }, [comments, commentsInitialized]);
  
  // 监听notification状态变化，确保动画触发
  useEffect(() => {
    if (notification) {
      // 延迟一帧，确保DOM已经更新
      requestAnimationFrame(() => {
        const toastElement = document.querySelector('.elegant-auth-toast');
        if (toastElement) {
          // 移除并重新添加类以重新触发动画
          toastElement.classList.remove('elegant-auth-toast');
          // 触发重排，强制浏览器重新计算样式
          const _ = toastElement.offsetWidth;
          toastElement.classList.add('elegant-auth-toast');
        }
      });
    }
  }, [notification]);
  
  if (loading) {
    return (
      <div className="elegant-app">
        <Header />
        <div className="elegant-loading-screen-orange">
          <div className="elegant-loading-indicator">
            <div className="elegant-loading-spinner-white"></div>
            <div className="elegant-loading-spinner-inner-white"></div>
          </div>
        </div>
        <Footer />
      </div>
    );
  }
  
  if (!puzzle) {
    return (
      <div className="elegant-app">
        <Header />
        <main className="elegant-main">
          <div className="elegant-not-found" style={{
            textAlign: 'center',
            padding: '50px 20px',
            maxWidth: '600px',
            margin: '50px auto',
            background: 'white',
            borderRadius: '12px',
            boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)'
          }}>
            <img 
              src="/images/404notfound.png" 
              alt="404 Not Found" 
              style={{
                width: '250px',
                marginBottom: '20px',
                display: 'block',
                margin: '0 auto 20px'
              }}
            />
            <h2 style={{ fontSize: '28px', marginBottom: '15px', color: '#333' }}>找不到该海龟汤</h2>
            <p style={{ fontSize: '16px', color: '#666', marginBottom: '30px', lineHeight: '1.6' }}>
              您查找的海龟汤可能已被删除或不存在。<br />
              请尝试查看其他有趣的海龟汤。
            </p>
            <Link to="/" style={{
              display: 'inline-block',
              padding: '12px 25px',
              background: 'linear-gradient(120deg, #ffdf5e 0%, #ffb347 100%)',
              color: 'white',
              borderRadius: '25px',
              textDecoration: 'none',
              fontWeight: 'bold',
              boxShadow: '0 2px 5px rgba(255, 179, 71, 0.3)',
              transition: 'all 0.3s ease'
            }}>
              <i className="fas fa-home" style={{ marginRight: '8px' }}></i>
              返回首页
            </Link>
          </div>
        </main>
        <Footer />
      </div>
    );
  }
  
  return (
    <div className="elegant-app">
      <style>
        {`
          @keyframes detailSpinner {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
          
          .detail-loading-spinner {
            width: 20px;
            height: 20px;
            border-radius: 50%;
            border: 2px solid rgba(255, 255, 255, 0.3);
            border-top: 2px solid white;
            animation: detailSpinner 1s linear infinite;
            display: inline-block;
          }
          
          /* API状态样式 */
          .ai-thinking-container {
            display: flex;
            align-items: center;
            justify-content: space-between;
          }
          
          .ai-thinking {
            display: flex;
            gap: 4px;
            margin-left: 10px;
          }
          
          .ai-thinking span {
            width: 8px;
            height: 8px;
            border-radius: 50%;
            background-color: #ffb347;
            opacity: 0.7;
            animation: thinking 1.4s infinite ease-in-out both;
          }
          
          .ai-thinking span:nth-child(1) {
            animation-delay: -0.32s;
          }
          
          .ai-thinking span:nth-child(2) {
            animation-delay: -0.16s;
          }
          
          @keyframes thinking {
            0%, 80%, 100% { 
              transform: scale(0.4);
              opacity: 0.4;
            }
            40% { 
              transform: scale(1.0);
              opacity: 1;
            }
          }
          
          .api-status-connecting, .api-status-sending, .api-status-processing, .api-status-waiting, .api-status-retrying {
            background-color: #f9f6f0 !important;
            border-left: 3px solid #ffb347 !important;
          }
          
          .api-status-error {
            background-color: #fff9f9 !important;
            border-left: 3px solid #ff6b6b !important;
          }
          
          .api-status-suspicious {
            background-color: #fffbf0 !important;
            border-left: 3px solid #ffc107 !important;
          }
          
          .api-status-completed {
            background-color: #f7fbf7 !important;
            border-left: 3px solid #4caf50 !important;
          }
          
          .ai-error-container p {
            color: #e53935;
          }
          
          .ai-suspicious-container p {
            color: #ff8f00;
          }
          
          .ai-debug-info {
            font-size: 10px;
            color: #999;
            margin-top: 5px;
            padding-top: 5px;
            border-top: 1px dashed #eee;
          }
        `}
      </style>
      <Header onNavigate={handleExitConfirm} />
      <main className="elegant-main">
        {notification && (
          <div 
            className={`elegant-auth-toast ${notification.type}`} 
            onClick={() => {
              if (notification.isLoginPrompt) {
                handleLogin();
              }
            }}
            key={notification.key || Date.now()}
          >
            {notification.message}
            {notification.isLoginPrompt && (
              <span className="login-prompt">
                点击登录
              </span>
            )}
          </div>
        )}
        
        <div className="puzzle-detail-container">
          <div className="puzzle-content-section" ref={puzzleContentRef}>
            <div className="puzzle-header">
              <div className="puzzle-header-flex" style={{ display: 'flex', alignItems: 'flex-start', gap: '20px' }}>
                <div className="elegant-puzzle-cover" style={{ 
                  flex: 'none', 
                  width: '240px !important', 
                  height: '240px !important',
                  minWidth: '240px !important', 
                  minHeight: '240px !important',
                  maxWidth: '240px !important',
                  maxHeight: '240px !important',
                  overflow: 'hidden',
                  borderRadius: '16px',
                  display: 'block',
                  position: 'relative',
                  boxSizing: 'border-box !important',
                  transform: 'scale(1)',
                  marginBottom: '20px'
                }}>
                  <div style={{
                    width: '100%',
                    height: '100%',
                    position: 'relative',
                    paddingBottom: '100%'
                  }}>
                    <img 
                      src={puzzle.coverImage || '/images/default.png'} 
                      alt={puzzle.title}
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = '/images/default.png';
                      }}
                      style={{
                        position: 'absolute',
                        top: '0',
                        left: '0',
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover',
                        borderRadius: '16px'
                      }}
                    />
              </div>
              </div>
                
                <div style={{ 
                  flex: '1', 
                  display: 'flex', 
                  flexDirection: 'column', 
                  height: '240px',
                  justifyContent: 'space-between',
                  position: 'relative'
                }}>
                  <div>
                    <h1 style={{ marginTop: '0', marginBottom: '10px' }}>{puzzle.title}</h1>
                    
                    <div className="puzzle-description" style={{ 
                      color: '#666', 
                      fontSize: '14px', 
                      marginBottom: '15px',
                      lineHeight: '1.4'
                    }}>
                      {puzzle.description}
            </div>
            
                    <div style={{ 
                      display: 'flex',
                      flexDirection: 'column',
                      gap: '6px',
                      marginTop: '-7px'
                    }}>
                      <div className="puzzle-author" style={{ display: 'flex', alignItems: 'center', gap: '5px', fontSize: '16px' }}>
                        {puzzle.creator}
                        <span style={{ margin: '0 5px', color: '#ddd' }}>|</span>
                        <button 
                          className={`follow-button ${isFollowing ? 'following' : ''}`}
                          onClick={handleFollow}
                          style={{ 
                            padding: 0,
                            fontSize: '16px',
                            background: 'none',
                            border: 'none',
                            cursor: 'pointer',
                            transition: 'all 0.3s ease',
                            display: 'inline-flex',
                            alignItems: 'center',
                            marginLeft: '2px',
                            color: isFollowing ? '#666' : 'transparent',
                            fontWeight: 'bold',
                            whiteSpace: 'nowrap',
                            fontFamily: '"Microsoft YaHei", "微软雅黑", sans-serif',
                            background: isFollowing ? 'none' : 'linear-gradient(120deg, #ffdf5e 0%, #ffb347 100%)',
                            WebkitBackgroundClip: 'text',
                            backgroundClip: 'text',
                            transform: 'none', /* 确保没有上移变形效果 */
                            "&:hover": {
                              transform: 'none'  /* 悬停时也不要有上移变形效果 */
                            }
                          }}
                        >
                          {isFollowing ? '取消关注' : '关注作者'}
                        </button>
                      </div>
                      
                      <div className="puzzle-date" style={{ color: '#888', marginLeft: '0', paddingLeft: '0', textAlign: 'left', width: '100%', marginTop: '1.5px', fontSize: '14px' }}>
                        发布于 {puzzle.date}
                      </div>
                      
                      <div className="puzzle-difficulty-category" style={{ color: '#888', marginLeft: '0', paddingLeft: '0', textAlign: 'left', width: '100%', fontSize: '14px', marginTop: '4px' }}>
                        发布于 {puzzle.date}
                        <br/>
                        难度等级：
                        <span style={{ color: '#888' }}>
                          {puzzle.difficulty === 'easy' ? '简单' : puzzle.difficulty === 'medium' ? '中等' : '困难'}
                        </span>
                        
                        <span style={{ margin: '0 5px' }}>·</span>
                        
                        分类：
                        <span style={{ color: '#888' }}>
                          {puzzle.category}
                        </span>
                      </div>
                    </div>
                  </div>
                  
                  <div className="puzzle-interactions" style={{ 
                    display: 'flex', 
                    gap: '15px', 
                    alignSelf: 'flex-end',
                    position: 'absolute',
                    bottom: '0',
                    left: '0'
                  }}>
                    <div className="interaction-item">
                      <button 
                        className={`interaction-btn like-btn ${isLiked ? 'active' : ''}`} 
                        onClick={handleLike}
                        style={{
                          background: 'none',
                          border: 'none',
                          padding: '8px',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          cursor: 'pointer'
                        }}
                      >
                        <i 
                          className={isLiked ? 'fas fa-heart' : 'far fa-heart'}
                          style={{ 
                            fontSize: '18px',
                            color: isLiked ? 'transparent' : '#666',
                            background: isLiked ? 'linear-gradient(120deg, #ffdf5e 0%, #ffb347 100%)' : 'none',
                            WebkitBackgroundClip: isLiked ? 'text' : 'none',
                            backgroundClip: isLiked ? 'text' : 'none',
                            WebkitTextFillColor: isLiked ? 'transparent' : 'inherit'
                          }}
                        ></i>
                      </button>
                      <span className="interaction-count">{likeCount}</span>
                    </div>
                    
                    <div className="interaction-item">
                      <button 
                        className={`interaction-btn share-btn ${isShared ? 'active' : ''}`} 
                        onClick={handleShare}
                        style={{
                          background: 'none',
                          border: 'none',
                          padding: '8px',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          cursor: 'pointer'
                        }}
                      >
                        <i 
                          className="fas fa-share-alt"
                          style={{ 
                            fontSize: '18px',
                            color: isShared ? 'transparent' : '#666',
                            background: isShared ? 'linear-gradient(120deg, #ffdf5e 0%, #ffb347 100%)' : 'none',
                            WebkitBackgroundClip: isShared ? 'text' : 'none',
                            backgroundClip: isShared ? 'text' : 'none',
                            WebkitTextFillColor: isShared ? 'transparent' : 'inherit'
                          }}
                        ></i>
                      </button>
                      <span className="interaction-count">{shareCount}</span>
                    </div>
                    
                    <div className="interaction-item">
                      <button 
                        className="interaction-btn view-btn" 
                        disabled
                        style={{
                          background: 'none',
                          border: 'none',
                          padding: '8px',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          cursor: 'default'
                        }}
                      >
                        <i 
                          className="fas fa-eye"
                          style={{ 
                            fontSize: '18px',
                            color: '#666'
                          }}
                        ></i>
                      </button>
                      <span className="interaction-count">{puzzle.views || 0}</span>
                    </div>
                  </div>
              </div>
              </div>
            </div>
            
            <div className="puzzle-story" style={{ 
              marginTop: '-385px'
            }}>
              <h2 style={{ marginBottom: '20px' }}>海龟汤 汤面</h2>
              <div className="puzzle-text" style={{ marginTop: '20px' }}>
                {puzzle.content.split('\n\n').map((paragraph, index) => (
                  <p key={index}>{paragraph}</p>
                ))}
              </div>
              
              {!isGameStarted && (
                <div style={{ 
                  display: 'flex', 
                  justifyContent: 'flex-end', 
                  marginTop: '20px',
                  position: 'relative',
                  zIndex: 10
                }}>
                  <button 
                    className="start-game-button" 
                    onClick={handleStartGame}
                    style={{ 
                      margin: '0',
                      padding: '10px 20px',
                      backgroundColor: '#ff9800',
                      color: 'white',
                      border: 'none',
                      borderRadius: '50px',
                      fontSize: '16px',
                      display: 'inline-flex',
                      alignItems: 'center',
                      gap: '8px',
                      boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
                      cursor: 'pointer',
                      width: 'auto',
                      transition: 'background-color 0.3s'
                    }}
                  >
                    <i className="fas fa-play-circle"></i> 开始解密
                  </button>
                </div>
              )}
            </div>

            {showSolution && (
              <div className="puzzle-solution">
                <h2>解答</h2>
                <div className="solution-text">
                  {puzzle.solution}
                </div>
              </div>
            )}
          </div>

          <div className="puzzle-interaction-section">
            <div className="interaction-header">
              <div className="interaction-header-top">
                <h2>询问问题</h2>
                <div className="user-coins">
                  <i className="fas fa-coins"></i> {turtleCoins} 海龟币
                </div>
              </div>
              
              <div style={{
                display: 'flex', 
                justifyContent: 'space-between',
                alignItems: 'center',
                padding: '0 5px',
                width: '100%'
              }}>
                <div className="questions-remaining">
                  <i className="fas fa-question-circle"></i> 
                  <span>剩余提问次数: {remainingQuestions}</span>
                </div>
                
                  <button 
                    className="add-questions-button"
                    onClick={handleAddQuestions}
                    disabled={turtleCoins < COINS_PER_QUESTION}
                  >
                  用 24 币兑换 3 次
                  </button>
              </div>
              
              {showCoinAlert && (
                <div className="coin-alert">
                  <i className="fas fa-exclamation-circle"></i> 海龟币不足，无法添加次数
                </div>
              )}
              
              {successMessage && (
                <div className="success-message">
                  <i className="fas fa-check-circle"></i> {successMessage}
                </div>
              )}
            </div>

            <div className="chat-messages" style={{ 
              backgroundColor: '#f8f8f8',
              height: '420px' // 增加高度
            }}>
                  {aiResponses.length === 0 && (
                    <div className="empty-messages">
                      {isGameStarted ? '开始提问来获取线索...' : '请先开始解谜以提问'}
                    </div>
                  )}
                  
                  {aiResponses.map((response, index) => (
                    <div key={index} className="chat-message">
                      <div className="user-message" style={{ background: 'linear-gradient(120deg, #ffdf5e 0%, #ffb347 100%)' }}>
                        <p>{response.question}</p>
                      </div>
                  
                  {response.answer !== null ? (
                      <div className={`ai-message ${response.apiStatus ? `api-status-${response.apiStatus}` : ''}`}>
                        {/* 根据API状态显示不同样式 */}
                        {response.apiStatus && ['connecting', 'sending', 'processing', 'waiting', 'retrying'].includes(response.apiStatus) ? (
                          <div className="ai-thinking-container">
                            <p>{response.answer}</p>
                            <div className="ai-thinking">
                              <span></span>
                              <span></span>
                              <span></span>
                            </div>
                          </div>
                        ) : response.apiStatus === 'error' ? (
                          <div className="ai-error-container">
                            <p>{response.answer}</p>
                          </div>
                        ) : response.apiStatus === 'suspicious' ? (
                          <div className="ai-suspicious-container">
                            <p>{response.answer}</p>
                            {process.env.NODE_ENV === 'development' && response.debug && (
                              <div className="ai-debug-info">{response.debug}</div>
                            )}
                          </div>
                        ) : (
                          <p>{response.answer}</p>
                        )}
                      </div>
                  ) : (
                    <div className="ai-message" style={{ backgroundColor: 'white' }}>
                      <div className="ai-thinking">
                        <span></span>
                        <span></span>
                        <span></span>
                      </div>
                    </div>
                  )}
                    </div>
                  ))}
                </div>

            <div className="input-mode-tabs" style={{ 
              marginTop: '15px',
              display: 'flex',
              gap: '10px'
            }}>
              <button 
                className={`mode-tab ${inputMode === 'question' ? 'active' : ''}`} 
                onClick={() => {
                  setInputMode('question');
                  setGuessResult(null);
                }}
                style={{
                  flex: 1,
                  padding: '12px 20px',
                  background: inputMode === 'question' ? 'linear-gradient(120deg, #ffdf5e 0%, #ffb347 100%)' : 'white',
                  color: inputMode === 'question' ? 'white' : '#666',
                  border: 'none',
                  borderRadius: '25px',
                  fontSize: '15px',
                  fontWeight: 'bold',
                  cursor: 'pointer',
                  transition: 'all 0.3s',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '8px',
                  boxShadow: inputMode === 'question' ? '0 2px 4px rgba(255, 179, 71, 0.2)' : 'none',
                  fontFamily: '"Microsoft YaHei", "微软雅黑", sans-serif'
                }}
              >
                <i className="fas fa-question-circle"></i> 询问问题
              </button>
              <button 
                className={`mode-tab ${inputMode === 'answer' ? 'active' : ''}`} 
                onClick={() => setInputMode('answer')}
                style={{
                  flex: 1,
                  padding: '12px 20px',
                  background: inputMode === 'answer' ? 'linear-gradient(120deg, #ffdf5e 0%, #ffb347 100%)' : 'white',
                  color: inputMode === 'answer' ? 'white' : '#666',
                  border: 'none',
                  borderRadius: '25px',
                  fontSize: '15px',
                  fontWeight: 'bold',
                  cursor: 'pointer',
                  transition: 'all 0.3s',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '8px',
                  boxShadow: inputMode === 'answer' ? '0 2px 4px rgba(255, 179, 71, 0.2)' : 'none',
                  fontFamily: '"Microsoft YaHei", "微软雅黑", sans-serif'
                }}
              >
                <i className="fas fa-lightbulb"></i> 提交答案
              </button>
            </div>

            <div className="chat-input" style={{ marginTop: '15px' }}>
              {inputMode === 'question' ? (
                <form onSubmit={handleSubmitQuestion} style={{ display: 'flex', gap: '10px' }}>
                  <input
                    type="text"
                    value={question}
                    onChange={(e) => setQuestion(e.target.value)}
                    placeholder={isGameStarted ? "输入你的问题..." : "请先开始解谜以提问"}
                    disabled={!isGameStarted || remainingQuestions <= 0 || isLoading}
                    style={{ 
                      height: '50px',
                      padding: '12px 18px',
                      flex: '1',
                      border: '1px solid #eee', 
                      borderRadius: '25px',
                      fontSize: '15px',
                      background: 'white',
                      boxShadow: 'none',
                      transition: 'all 0.3s'
                    }}
                  />
                  <button 
                    type="submit"
                    disabled={!question.trim() || !isGameStarted || remainingQuestions <= 0 || isLoading}
                    style={{ 
                      width: '50px', 
                      height: '50px',
                      background: 'linear-gradient(120deg, #ffdf5e 0%, #ffb347 100%)',
                      color: 'white',
                      border: 'none',
                      borderRadius: '50%',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      boxShadow: '0 2px 4px rgba(255, 179, 71, 0.2)',
                      transition: 'all 0.3s'
                    }}
                  >
                    {isLoading ? (
                      <div className="detail-loading-spinner"></div>
                    ) : <i className="fas fa-paper-plane"></i>}
                  </button>
                </form>
              ) : (
                <form onSubmit={handleSubmitGuess} style={{ display: 'flex', gap: '10px' }}>
                  <input
                    type="text"
                    value={guessInput}
                    onChange={(e) => setGuessInput(e.target.value)}
                    placeholder={isGameStarted ? "输入你的答案..." : "请先开始解谜以答题"}
                    disabled={!isGameStarted || isLoading}
                    style={{ 
                      height: '50px',
                      padding: '12px 18px',
                      flex: '1',
                      border: '1px solid #eee',
                      borderRadius: '25px',
                      fontSize: '15px',
                      background: 'white',
                      boxShadow: 'none',
                      transition: 'all 0.3s'
                    }}
                  />
                  <button 
                    type="submit"
                    disabled={!guessInput.trim() || !isGameStarted || isLoading}
                    style={{ 
                      width: '50px', 
                      height: '50px',
                      background: 'linear-gradient(120deg, #ffdf5e 0%, #ffb347 100%)',
                      color: 'white',
                      border: 'none',
                      borderRadius: '50%',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      boxShadow: '0 2px 4px rgba(255, 179, 71, 0.2)',
                      transition: 'all 0.3s'
                    }}
                  >
                    {isLoading ? (
                      <div className="detail-loading-spinner"></div>
                    ) : <i className="fas fa-check"></i>}
                  </button>
                </form>
              )}
            </div>

                {/* 移除guessResult长方形提示区域
                {guessResult && (
                  <div className={`guess-result ${guessResult.correct ? 'correct' : 'incorrect'}`}>
                <i className={`fas ${guessResult.correct ? 'fa-check-circle' : 'fa-times-circle'}`}></i>
                <p>{guessResult.message}</p>
                  </div>
                )}
                */}
              </div>
            </div>

        <div className="comments-section" style={{ 
          width: '100%',
          maxWidth: '100%',
          margin: '20px auto',
          padding: '0',
          boxSizing: 'border-box',
          contain: 'content',
          transform: 'translateZ(0)',
          backfaceVisibility: 'hidden'
        }}>
          <div className="comments-container" style={{ 
            width: '100%',
            margin: '0 auto',
            background: '#fff',
            borderRadius: '25px',
            boxShadow: '2px 2px 4px rgba(255, 179, 71, 0.2), -2px -2px 4px rgba(255, 179, 71, 0.2), -2px 2px 4px rgba(255, 179, 71, 0.2), 2px -2px 4px rgba(255, 179, 71, 0.2)',
            padding: '20px',
            position: 'relative',
            contain: 'content',
            transform: 'translateZ(0)',
            backfaceVisibility: 'hidden'
          }}>
            <h2 className="comments-title">
              <i className="fas fa-comments"></i> 评论区
              <span className="comments-count">({comments.length})</span>
            </h2>
            
            {loadingComments ? (
              <div className="comments-loading" style={{ 
                textAlign: 'center', 
                padding: '20px',
                transform: 'translateZ(0)',
                background: '#fff',
                borderRadius: '12px',
                margin: '20px 0',
                boxShadow: '0 2px 10px rgba(0, 0, 0, 0.05)'
              }}>
                <div style={{
                  width: '40px',
                  height: '40px',
                  borderRadius: '50%',
                  border: '4px solid rgba(255, 179, 71, 0.2)',
                  borderTopColor: '#ffb347',
                  animation: 'spin 1s linear infinite',
                  margin: '0 auto 15px'
                }}></div>
                <p style={{transform: 'translateZ(0)', color: '#666', fontWeight: '500'}}>加载评论中...</p>
              </div>
            ) : comments.length === 0 ? (
              <div className="no-comments">
                <i className="far fa-comment-dots"></i>
                <p>暂无评论，快来发表第一条评论吧！</p>
              </div>
            ) : (
              <div className="comments-list" style={{
                contain: 'content',
                transform: 'translateZ(0)'
              }}>
                {/* 使用记忆化的评论列表渲染函数 */}
                {renderComments()}
                
                {comments.length > 3 && !showAllComments && (
                  <button className="load-more-comments" onClick={() => setShowAllComments(true)}>
                    <i className="fas fa-chevron-down" style={{ marginRight: '8px', position: 'relative', top: '2.6px' }}></i>
                    展开更多评论 ({comments.length - 3})
                  </button>
                )}
              </div>
            )}
            
            {/* 将有条件渲染改为始终显示评论框 */}
            <div className="comment-form" style={{ 
              marginBottom: '20px',
              contain: 'layout paint',
              padding: '0 16px', // 添加左右内边距，确保与其他评论内容对齐
              width: '100%',
              boxSizing: 'border-box',
              display: 'flex',
              flexDirection: 'column',
              transform: 'translateZ(0)'
            }} id="comment-form">
              {/* 注释掉回复面板相关代码
              {replyingTo && (
                <div style={{ 
                  marginBottom: '5px', 
                  marginTop: '20px',
                  padding: '10px 12px',
                  backgroundColor: '#f9f9f9',
                  borderRadius: '12px',
                  contain: 'content',
                  overflow: 'hidden',
                  whiteSpace: 'nowrap',
                  textOverflow: 'ellipsis',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  height: '50px',
                  boxSizing: 'border-box',
                  border: '1px solid #eaeaea',
                  width: 'calc(100% - 30px)', 
                  margin: '0 auto 5px auto',
                  transform: 'translateZ(0)'
                }}>
                  <div style={{ 
                    overflow: 'hidden',
                    whiteSpace: 'nowrap',
                    textOverflow: 'ellipsis',
                    flex: '1',
                    color: '#666',
                    fontSize: '14px',
                    transform: 'translateZ(0)'
                  }}>
                    <span style={{fontWeight: 'normal'}}>回复给 </span>
                    <strong>{getReplyUserName()}</strong>
                    <span>：</span>
                    <span style={{ 
                      fontStyle: 'italic', 
                      color: '#666',
                      marginLeft: '5px',
                      overflow: 'hidden',
                      whiteSpace: 'nowrap',
                      textOverflow: 'ellipsis'
                    }}>
                      {getCommentSummary(replyingTo, replyingToReply, replyingToParent)}
                    </span>
                  </div>
                  <button
                    onClick={() => {
                      setReplyingTo(null);
                      setReplyingToReply(false);
                      setReplyingToParent(null);
                    }}
                    style={{
                      backgroundColor: '#f0f0f0',
                      color: '#666',
                      border: 'none',
                      borderRadius: '50px',
                      padding: '4px 10px',
                      cursor: 'pointer',
                      fontSize: '12px',
                      height: '28px',
                      display: 'inline-flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      boxShadow: '0 1px 2px rgba(0,0,0,0.1)',
                      transition: 'background-color 0.3s',
                      flexShrink: 0,
                      marginLeft: '10px',
                      transform: 'translateZ(0)'
                    }}
                  >
                    取消回复
                  </button>
                </div>
              )}
              */}
              <div style={{ width: 'calc(100% - 30px)', margin: '0 auto' }}>
                <textarea
                  value={commentText}
                  onChange={(e) => setCommentText(e.target.value)}
                  placeholder="留下你的精彩见解..."
                  style={{
                    width: '100%',
                    padding: '12px 18px',
                    borderRadius: '25px',
                    border: '1px solid #eee',
                    marginBottom: '10px',
                    marginTop: '8px',
                    marginLeft: '0',
                    marginRight: '0',
                    resize: 'none',
                    height: '85px',
                    fontFamily: 'inherit',
                    fontSize: '15px',
                    background: 'white',
                    transition: 'all 0.3s',
                    boxShadow: 'none',
                    outline: 'none'
                  }}
                  onFocus={(e) => {
                    e.target.style.boxShadow = '0 0 0 2px rgba(255, 179, 71, 0.2)';
                    e.target.style.borderColor = '#ffb347';
                  }}
                  onBlur={(e) => {
                    e.target.style.boxShadow = 'none';
                    e.target.style.borderColor = '#eee';
                  }}
                />
                <div style={{ 
                  display: 'flex', 
                  justifyContent: 'flex-end', 
                  width: '100%',
                  marginLeft: '0',
                  marginRight: '0',
                  transform: 'translateZ(0)'
                }}>
                  <button
                    onClick={(e) => {
                      e.preventDefault();
                      if (!isLoggedIn) {
                        showNotification('请先登录后发表评论', 'error', true);
                      } /* 注释掉回复逻辑
                      else if (replyingTo) {
                        // 如果是回复，使用handleCommentSubmit
                        handleCommentSubmit(e);
                      } */ 
                      else {
                        // 如果是新评论，使用addComment
                        addComment();
                      }
                    }}
                    style={{ 
                      margin: '0',
                      padding: '10px 20px',
                      background: 'linear-gradient(120deg, #ffdf5e 0%, #ffb347 100%)',
                      color: 'white',
                      border: 'none',
                      borderRadius: '50px',
                      fontSize: '16px',
                      display: 'inline-flex',
                      alignItems: 'center',
                      gap: '8px',
                      boxShadow: '0 2px 4px rgba(255, 179, 71, 0.2)',
                      cursor: 'pointer',
                      width: 'auto',
                      transition: 'all 0.3s',
                      minWidth: '120px',
                      height: '40px',
                      justifyContent: 'center',
                      transform: 'translateZ(0)'
                    }}
                  >
                    <i className="fas fa-paper-plane"></i> 发表评论
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
      <Footer />
      {showShareDialog && (
        <div className="share-dialog-overlay">
          <div className="share-dialog">
            <div className="share-dialog-header">
              <h3>转发 分享到</h3>
              <button className="share-close-btn" onClick={closeShareDialog}>
                <i className="fas fa-times"></i>
              </button>
            </div>
            
            <div className="share-options">
              <div className="share-option" onClick={() => handleShareTo('wechat-friend')}>
                <div className="share-icon wechat" style={{ 
                  display: 'flex', 
                  alignItems: 'center', 
                  justifyContent: 'center',
                  background: 'linear-gradient(120deg, #2EEA6E 0%, #1BD954 100%)'
                }}>
                  <i className="fab fa-weixin" style={{ color: '#fff' }}></i>
                </div>
                <span>微信</span>
              </div>
              
              <div className="share-option" onClick={() => handleShareTo('qq')}>
                <div className="share-icon qq" style={{ 
                  display: 'flex', 
                  alignItems: 'center', 
                  justifyContent: 'center',
                  background: 'linear-gradient(120deg, #36D1FF 0%, #18B6F6 100%)'
                }}>
                  <i className="fab fa-qq" style={{ color: '#fff' }}></i>
                </div>
                <span>QQ</span>
              </div>
              
              <div className="share-option" onClick={() => handleShareTo('weibo')}>
                <div className="share-icon weibo" style={{ 
                  display: 'flex', 
                  alignItems: 'center', 
                  justifyContent: 'center',
                  background: 'linear-gradient(120deg, #FF7A7A 0%, #FF5252 100%)'
                }}>
                  <i className="fab fa-weibo" style={{ color: '#fff' }}></i>
                </div>
                <span>微博</span>
              </div>
              
              <div className="share-option" onClick={() => handleShareTo('forum')}>
                <div className="share-icon forum" style={{ background: 'linear-gradient(120deg, #ffdf5e 0%, #ffb347 100%)' }}>
                  <i className="fas fa-paper-plane" style={{ fontSize: '0.8em', marginLeft: '-3px' }}></i>
                </div>
                <span>论坛</span>
              </div>
            </div>
            
            <div className="share-preview">
              <div className="preview-image" style={{display: 'block', visibility: 'visible', opacity: 1}}>
                <img 
                  src={puzzle.coverImage || '/images/default.png'} 
                  alt={puzzle.title} 
                  style={{
                    width: '100%', 
                    height: '100%', 
                    objectFit: 'cover', 
                    display: 'block', 
                    visibility: 'visible', 
                    opacity: 1
                  }}
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = '/images/default.png';
                  }}
                />
              </div>
              <div className="preview-content">
                <h4>{puzzle.title}</h4>
                <p>{puzzle.description}</p>
              </div>
            </div>
          </div>
        </div>
      )}
      {reportDialogOpen && (
        <div className="report-dialog-overlay" style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.6)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 9999999
        }}>
          <div 
            className="report-dialog" 
            style={{
              backgroundColor: 'white',
              borderRadius: '16px',
              boxShadow: '0 10px 40px rgba(0, 0, 0, 0.2)',
              width: '450px',
              maxWidth: 'calc(100vw - 40px)',
              overflow: 'hidden'
            }}
            onClick={(e) => {
              // 防止点击对话框时关闭下拉菜单
              e.stopPropagation();
            }}
          >
            <div className="report-dialog-header" style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              padding: '18px 24px',
              borderBottom: '1px solid #eee'
            }}>
              <h3 style={{
                margin: 0,
                fontSize: '18px',
                fontWeight: 'bold',
                color: '#333',
                fontFamily: '"Microsoft YaHei", "微软雅黑", sans-serif'
              }}>举报评论</h3>
              <button className="report-close-btn" onClick={cancelReport} style={{
                background: 'none',
                border: 'none',
                color: '#888',
                fontSize: '18px',
                cursor: 'pointer',
                width: '30px',
                height: '30px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                borderRadius: '50%',
                transition: 'all 0.2s'
              }}>
                <i className="fas fa-times"></i>
              </button>
            </div>
            
            <div className="report-form" style={{
              padding: '24px'
            }}>
              <label htmlFor="report-reason" style={{
                display: 'block',
                marginBottom: '16px',
                fontWeight: '500',
                color: '#333',
                fontSize: '15px',
                fontFamily: '"Microsoft YaHei", "微软雅黑", sans-serif'
              }}>举报原因：</label>

              <div style={{ 
                display: 'flex', 
                flexDirection: 'column', 
                gap: '10px'
              }}>
                <button 
                  type="button" 
                  onClick={() => setReportReason('spam')}
                  style={{ 
                    display: 'flex', 
                    alignItems: 'center',
                    padding: '10px 16px',
                    marginBottom: '8px',
                    borderRadius: '6px',
                    border: '1px solid #e0e0e0',
                    background: reportReason === 'spam' 
                      ? 'linear-gradient(120deg, #ffdf5e 0%, #ffb347 100%)' 
                      : 'linear-gradient(135deg, #f8f8f8 0%, #f0f0f0 100%)',
                    color: reportReason === 'spam' ? 'white' : '#555',
                    cursor: 'pointer',
                    textAlign: 'left',
                    fontSize: '14px',
                    fontWeight: reportReason === 'spam' ? '600' : '400',
                    fontFamily: '"Microsoft YaHei", "微软雅黑", sans-serif',
                    transition: 'all 0.2s ease',
                    boxShadow: reportReason === 'spam' ? '0 2px 5px rgba(255, 152, 0, 0.2)' : 'none',
                    width: '100%'
                  }}
                >
                  垃圾信息
                </button>

                <button 
                  type="button" 
                  onClick={() => setReportReason('offensive')}
                    style={{ 
                    display: 'flex',
                    alignItems: 'center',
                    padding: '10px 16px',
                    marginBottom: '8px',
                    borderRadius: '6px',
                    border: '1px solid #e0e0e0',
                    background: reportReason === 'offensive' 
                      ? 'linear-gradient(120deg, #ffdf5e 0%, #ffb347 100%)' 
                      : 'linear-gradient(135deg, #f8f8f8 0%, #f0f0f0 100%)',
                    color: reportReason === 'offensive' ? 'white' : '#555',
                    cursor: 'pointer',
                    textAlign: 'left',
                    fontSize: '14px',
                    fontWeight: reportReason === 'offensive' ? '600' : '400',
                    fontFamily: '"Microsoft YaHei", "微软雅黑", sans-serif',
                    transition: 'all 0.2s ease',
                    boxShadow: reportReason === 'offensive' ? '0 2px 5px rgba(255, 152, 0, 0.2)' : 'none',
                    width: '100%'
                      }}
                    >
                      冒犯性内容
                </button>

                <button 
                  type="button" 
                  onClick={() => setReportReason('inappropriate')}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    padding: '10px 16px',
                    marginBottom: '8px',
                    borderRadius: '6px',
                    border: '1px solid #e0e0e0',
                    background: reportReason === 'inappropriate' 
                      ? 'linear-gradient(120deg, #ffdf5e 0%, #ffb347 100%)' 
                      : 'linear-gradient(135deg, #f8f8f8 0%, #f0f0f0 100%)',
                    color: reportReason === 'inappropriate' ? 'white' : '#555',
                    cursor: 'pointer',
                    textAlign: 'left',
                    fontSize: '14px',
                    fontWeight: reportReason === 'inappropriate' ? '600' : '400',
                    fontFamily: '"Microsoft YaHei", "微软雅黑", sans-serif',
                    transition: 'all 0.2s ease',
                    boxShadow: reportReason === 'inappropriate' ? '0 2px 5px rgba(255, 152, 0, 0.2)' : 'none',
                    width: '100%'
                      }}
                    >
                      不适当内容
                </button>

                <button 
                  type="button" 
                  onClick={() => setReportReason('illegal')}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    padding: '10px 16px',
                    marginBottom: '8px',
                    borderRadius: '6px',
                    border: '1px solid #e0e0e0',
                    background: reportReason === 'illegal' 
                      ? 'linear-gradient(120deg, #ffdf5e 0%, #ffb347 100%)' 
                      : 'linear-gradient(135deg, #f8f8f8 0%, #f0f0f0 100%)',
                    color: reportReason === 'illegal' ? 'white' : '#555',
                    cursor: 'pointer',
                    textAlign: 'left',
                    fontSize: '14px',
                    fontWeight: reportReason === 'illegal' ? '600' : '400',
                    fontFamily: '"Microsoft YaHei", "微软雅黑", sans-serif',
                    transition: 'all 0.2s ease',
                    boxShadow: reportReason === 'illegal' ? '0 2px 5px rgba(255, 152, 0, 0.2)' : 'none',
                    width: '100%'
                      }}
                    >
                      违法内容
                </button>

                <button 
                  type="button" 
                      onClick={() => {
                        setReportReason('other');
                        setReportDetailRequired(true);
                  }}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    padding: '10px 16px',
                    marginBottom: '8px',
                    borderRadius: '6px',
                    border: '1px solid #e0e0e0',
                    background: reportReason === 'other' 
                      ? 'linear-gradient(120deg, #ffdf5e 0%, #ffb347 100%)' 
                      : 'linear-gradient(135deg, #f8f8f8 0%, #f0f0f0 100%)',
                    color: reportReason === 'other' ? 'white' : '#555',
                    cursor: 'pointer',
                    textAlign: 'left',
                    fontSize: '14px',
                    fontWeight: reportReason === 'other' ? '600' : '400',
                    fontFamily: '"Microsoft YaHei", "微软雅黑", sans-serif',
                    transition: 'all 0.2s ease',
                    boxShadow: reportReason === 'other' ? '0 2px 5px rgba(255, 152, 0, 0.2)' : 'none',
                    width: '100%'
                      }}
                    >
                      其他原因
                </button>
              </div>
              
              {reportReason === 'other' && (
                <textarea
                  className="report-detail"
                  placeholder="请详细说明举报原因..."
                  value={reportDetail}
                  onChange={(e) => setReportDetail(e.target.value)}
                  required
                  style={{
                    width: '100%',
                    padding: '12px 15px',
                    borderRadius: '8px',
                    border: '1px solid #e0e0e0',
                    fontSize: '15px',
                    marginTop: '15px',
                    resize: 'none',
                    fontFamily: '"Microsoft YaHei", "微软雅黑", sans-serif',
                    minHeight: '100px',
                    boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
                    outline: 'none'
                  }}
                  onFocus={(e) => {
                    e.target.style.borderColor = '#ff9800';
                    e.target.style.boxShadow = '0 0 0 3px rgba(255, 152, 0, 0.1)';
                  }}
                  onBlur={(e) => {
                    e.target.style.borderColor = '#e0e0e0';
                    e.target.style.boxShadow = '0 1px 3px rgba(0,0,0,0.05)';
                  }}
                ></textarea>
              )}
            </div>
            
            <div className="report-buttons" style={{
              display: 'flex',
              justifyContent: 'center',
              gap: '20px',
              margin: '20px 0 5px',
              padding: '0 24px 24px'
            }}>
              <button 
                type="button" 
                className="report-cancel-btn" 
                onClick={cancelReport} 
                style={{ 
                  fontFamily: '"Microsoft YaHei", "微软雅黑", sans-serif', 
                  fontWeight: 'bold',
                  padding: '10px 24px',
                  borderRadius: '20px',
                  fontSize: '15px',
                  cursor: 'pointer',
                  transition: 'all 0.2s',
                  minWidth: '100px',
                  backgroundColor: '#f0f0f0',
                  color: '#555',
                  border: 'none'
                }}
              >
                取消
              </button>
              <button 
                type="button" 
                className="report-submit-btn" 
                onClick={submitReport}
                disabled={reportReason === 'other' && !reportDetail.trim()}
                style={{ 
                  fontFamily: '"Microsoft YaHei", "微软雅黑", sans-serif', 
                  fontWeight: 'bold',
                  padding: '10px 24px',
                  borderRadius: '20px',
                  fontSize: '15px',
                  cursor: 'pointer',
                  transition: 'all 0.2s',
                  minWidth: '100px',
                  backgroundColor: '#ff9800',
                  background: 'linear-gradient(120deg, #ffdf5e 0%, #ffb347 100%)',
                  color: 'white',
                  border: 'none',
                  boxShadow: '0 2px 10px rgba(255, 179, 71, 0.3)'
                }}
              >
                提交举报
              </button>
            </div>
          </div>
        </div>
      )}
      {/* 确保评论渲染时不会闪烁 */}
      <style>
        {`
          /* 禁用可能导致重绘的CSS属性 */
          body {
            overflow-anchor: none !important;
          }
          .comments-section, 
          .comments-container,
          .comment-item,
          .reply-item,
          .nested-reply-item {
            content-visibility: auto;
            contain-intrinsic-size: auto 300px;
            contain: layout style paint;
          }
          
          /* 防止评论中的头像闪烁 */
          img {
            content-visibility: auto;
            will-change: contents;
          }
          
          /* 禁用所有CSS动画和过渡 */
          *, *::before, *::after {
            transition: none !important;
            animation: none !important;
            animation-duration: 0s !important;
          }
        `}
      </style>
      <style>
        {`
          /* 禁用可能导致重绘的CSS属性 */
          body {
            overflow-anchor: none !important;
          }
          .comments-section, 
          .comments-container,
          .comment-item,
          .reply-item,
          .nested-reply-item {
            content-visibility: auto;
            contain-intrinsic-size: auto 300px;
            contain: layout style paint;
          }
          
          /* 防止评论中的头像闪烁 */
          img {
            content-visibility: auto;
            will-change: contents;
          }
          
          /* 禁用所有CSS动画和过渡 */
          *, *::before, *::after {
            transition: none !important;
            animation: none !important;
            animation-duration: 0s !important;
          }
          
          /* 修改交互按钮的悬停样式 */
          .interaction-btn:hover {
            background-color: #e0e0e0 !important;
            color: #444 !important;
            transform: none !important;
          }
          
          /* 未点赞按钮悬停时变暗 */
          .like-btn:hover {
            color: #444 !important;
            background-color: #e0e0e0 !important;
          }
          
          /* 已点赞按钮悬停时变深橙色 */
          .like-btn.liked:hover {
            color: #e05e00 !important;
            background-color: #fff2e6 !important;
          }
          
          .share-btn:hover {
            color: #444 !important;
            background-color: #e0e0e0 !important;
          }
          
          .view-btn:hover {
            color: #444 !important;
            background-color: #e0e0e0 !important;
            cursor: default;
          }
        `}
      </style>
      <style jsx>{`
        // ... existing code ...
        
        .like-button {
          transition: all 0.2s ease;
        }
        
        .like-button:hover i {
          transform: scale(1.1);
        }
        
        .like-button.liked i {
          animation: heartBeat 0.3s ease-in-out;
        }
        
        @keyframes heartBeat {
          0% { transform: scale(1); }
          50% { transform: scale(1.3); }
          100% { transform: scale(1); }
        }
        
        // ... existing code ...
      `}</style>
      <style jsx>{`
        // ... existing code ...
        
        .like-button {
          transition: none;
        }
        
        .like-button:hover i {
          transform: none;
        }
        
        .like-button.liked i {
          animation: none;
        }
        
        .comment-actions button, .reply-actions button {
          margin-right: 4px;
        }
        
        // ... existing code ...
      `}</style>
      <style jsx>{`
        // ... existing code ...
        
        .elegant-custom-select {
          position: relative;
          z-index: 9999;
        }
        
        .elegant-select-header {
          background-color: #fff;
          border: 1px solid #ddd;
          border-radius: 4px;
          padding: 10px;
          cursor: pointer;
          display: flex;
          justify-content: space-between;
          align-items: center;
        }
        
        .elegant-select-options {
          position: absolute;
          top: 100%;
          left: 0;
          width: 100%;
          background-color: #fff;
          border: 1px solid #ddd;
          border-radius: 4px;
          box-shadow: 0 4px 8px rgba(0,0,0,0.2);
          max-height: 200px;
          overflow-y: auto;
          z-index: 99999;
        }
        
        .elegant-select-option {
          padding: 8px 12px;
          cursor: pointer;
          transition: background-color 0.2s;
        }
        
        .elegant-select-option:hover {
          background-color: #f5f5f5;
        }
        
        .elegant-select-option.active {
          background-color: #f0f0f0;
          font-weight: bold;
        }
        
        // ... existing code ...
      `}</style>
      <style jsx>{`
        // ... existing code ...
        
        .loading-spinner {
          width: 30px;
          height: 30px;
          border: 3px solid rgba(0, 0, 0, 0.1);
          border-radius: 50%;
          border-top-color: #ff9800;
          margin: 0 auto 10px;
          animation: spin 1s linear infinite;
        }
        
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
        
        // ... existing code ...
      `}</style>
      <style jsx>{`
        // ... existing code ...
        
        .like-button.liked i, .like-button.liked span {
          color: #ffa726 !important;
        }
        
        .comment-actions button, .reply-actions button {
          margin-right: 4px;
        }
        
        // ... existing code ...
      `}</style>
      <style jsx>{`
        // ... existing code ...
        
        .like-button.liked i, .like-button.liked span {
          color: #ffa726 !important;
        }
        
        .comment-actions button, .reply-actions button {
          margin-right: 2px;
        }
        
        .comment-actions .comment-reply, .reply-actions .reply-reply {
          margin-left: -2px;
        }
        
        // ... existing code ...
      `}</style>
      <style>
        {`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}
      </style>
    </div>
  );
};

export default Detail;